(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('core-js/modules/es.error.cause.js'), require('core-js/modules/esnext.iterator.constructor.js'), require('core-js/modules/esnext.iterator.find.js'), require('core-js/modules/esnext.iterator.map.js'), require('core-js/modules/esnext.iterator.filter.js'), require('core-js/modules/esnext.iterator.for-each.js'), require('core-js/modules/esnext.iterator.some.js'), require('vue'), require('axios'), require('crypto-js')) :
  typeof define === 'function' && define.amd ? define(['core-js/modules/es.error.cause.js', 'core-js/modules/esnext.iterator.constructor.js', 'core-js/modules/esnext.iterator.find.js', 'core-js/modules/esnext.iterator.map.js', 'core-js/modules/esnext.iterator.filter.js', 'core-js/modules/esnext.iterator.for-each.js', 'core-js/modules/esnext.iterator.some.js', 'vue', 'axios', 'crypto-js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["formPage/index"] = global["formPage/index"] || {}, global["formPage/index"].js = factory(null, null, null, null, null, null, null, global.Vue, global.axios, global.crypto)));
})(this, (function (es_error_cause_js, esnext_iterator_constructor_js, esnext_iterator_find_js, esnext_iterator_map_js, esnext_iterator_filter_js, esnext_iterator_forEach_js, esnext_iterator_some_js, Vue, axios, crypto) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);
  var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
  var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

  var flexBox = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexBoxWrap-21432143"},[_c('div',{ref:"flexBoxHead",staticClass:"flexBoxHead"},[_vm._t("head")],2),_vm._v(" "),_c('div',{staticClass:"flexBoxBody transparentScrollBar",style:(_vm.flexBoxBodyStyle)},[_vm._t("body")],2)])},
  staticRenderFns: [],
    name: "flexBox",
    data() {
      return {
        flexBoxHeadHeight: 0,
      };
    },
    computed: {
      flexBoxBodyStyle() {
        return "height: calc(100% - " + this.flexBoxHeadHeight + "px)";
      },
    },
    mounted() {
      this.flexBoxHeadHeight = this.$refs.flexBoxHead.offsetHeight;
      setTimeout(() => {
        this.flexBoxHeadHeight = this.$refs.flexBoxHead.offsetHeight;
      }, 1000);
    },
  };

  function isEmpty(value) {
    // null or undefined
    if (value == null) return true;
    // Strings
    if (typeof value === 'string' && value.trim() === '') return true;
    // Arrays
    if (Array.isArray(value) && value.length === 0) return true;
    // Objects
    if (typeof value === 'object' && Object.keys(value).length === 0) return true;
    // NaN
    if (typeof value === 'number' && isNaN(value)) return true;
    // Everything else is considered non-empty
    return false;
  }

  // 增加了国家代码后 原来的手机号校验要做一些变更
  function PhoneNumber(value, callBack, required, options) {
    const {
      CountryCode,
      validate_error_msg = '',
      open_limit_data_format
    } = options;
    if (!value && required == 2) {
      callBack(new Error(validate_error_msg.trim() || '请输入手机号'));
    } else if (value && CountryCode == '86' && isEmpty(open_limit_data_format) && !/^1[0-9]{10}$/.test(value)) {
      callBack(new Error('手机号格式不正确'));
    } else {
      callBack();
    }
  }
  function Email(value, callBack, required, options) {
    const {
      validate_error_msg = '',
      custom_validate_error_msg = '',
      open_limit_data_format
    } = options;
    if (!value && required == 2) {
      callBack(new Error(validate_error_msg.trim() || '请输入邮箱'));
    } else if (value && isEmpty(open_limit_data_format) && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)) {
      callBack(new Error(custom_validate_error_msg.trim() || '请输入正确的邮箱地址'));
    } else {
      callBack();
    }
  }
  function IdentityCard(value, callBack, required, options) {
    if (!value && required == 2) {
      callBack(new Error('请输入身份证号'));
    } else if (value && !/(^\d{18}$)|(^\d{17}(\sd|X|x)$)/.test(value)) {
      callBack(new Error('请输入正确的身份证号'));
    } else {
      callBack();
    }
  }
  function Default(value, callback, required, options = {}) {
    const {
      display_name,
      isRepeat,
      validate_error_msg = ''
    } = options;
    if (isEmpty(value) && required == 2) {
      callback(new Error(validate_error_msg.trim() || `${display_name || '此项'}必填`));
    } else if (isRepeat) {
      callback(new Error(`${display_name || '此项'}重复，请修改`));
    } else {
      callback();
    }
  }
  function URL(value, callBack, required, options) {
    const {
      display_name,
      validate_error_msg = '',
      open_limit_data_format
    } = options;
    const httpRegex = /^https?:\/\//;
    if (!value && required == 2) {
      callBack(new Error(validate_error_msg.trim() || `${display_name || '此项'}必填`));
    } else if (value && open_limit_data_format != 2 && !httpRegex.test(value)) {
      callBack(new Error('请输入 http:// | https:// 的URL'));
    } else {
      callBack();
    }
    return httpRegex;
  }
  function Text(value, callback, required, options) {
    const {
      num_range,
      validate_error_msg = '',
      custom_validate_error_msg = ''
    } = options;
    if (!value && required == 2) {
      callback(new Error(validate_error_msg.trim() || '请输入'));
    } else if (value && !isEmpty(value.min) && value.length < num_range.min) {
      callback(new Error(custom_validate_error_msg.trim() || `最小长度为 ${num_range.min}`));
      return;
    } else if (value && !isEmpty(value.min) && value.length > num_range.max) {
      callback(new Error(custom_validate_error_msg.trim() || `最大长度为 ${num_range.max}`));
      return;
    } else {
      callback();
    }
  }
  const TextArea = Text;
  function Image(value, callback, required, options = {}) {
    const {
      extra_restrict_rule = {},
      validate_error_msg = '',
      custom_validate_error_msg = ''
    } = options;
    const {
      min,
      max
    } = extra_restrict_rule;
    if (!value && required == 2) {
      callback(new Error(validate_error_msg.trim() || '此项必填'));
    } else if (Array.isArray(value) && value.length > 0) {
      if (value.length > 0 && value.length < min) {
        callback(new Error(custom_validate_error_msg.trim() || `最小数量为 ${min}`));
        return;
      } else if (value.length > 0 && value.length > max) {
        callback(new Error(custom_validate_error_msg.trim() || `最大数量为 ${max}`));
        return;
      } else {
        callback();
      }
    } else {
      callback();
    }
  }
  const Files = Image;
  const rules = {
    PhoneNumber: PhoneNumber,
    Email: Email,
    IdentityCard: IdentityCard,
    Default: Default,
    URL: URL,
    // Address: Address,
    Text,
    TextArea,
    Image,
    Files
  };

  function checkEmailDomainAllowed(email, allowedDomains) {
    const domainPattern = allowedDomains.join('|').replace(/\./g, '\\.');
    const regex = new RegExp(`(${domainPattern})$`, 'i'); // 匹配以 @ + 域名结尾
    return regex.test(email)
  }
  const checkEmailDomain = function (rule, value, callback) {
    const email_domain = this.currentItem.email_domain;
    const hasDomain = Array.isArray(email_domain) && email_domain.length > 0;
    if (value && hasDomain && checkEmailDomainAllowed(value, email_domain)) {
      callback(
        new Error(this.currentItem.email_domain_error_msg || '邮箱域名错误')
      );
    } else {
      callback();
    }
  };
  var zqFormItem = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$attrs.currentItem.isHidden == 1)?_c('el-form-item',{staticClass:"form-item-label-warp",attrs:{"prop":_vm.cusProps ? _vm.cusProps : _vm.$attrs.currentItem.field_name,"description":_vm.$attrs.currentItem.helpText,"helpTextType":_vm.$attrs.currentItem.helpTextType,"rules":_vm.rules},scopedSlots:_vm._u([{key:"error",fn:function(scope){return _c('span',{staticClass:"el-form-item__error",style:(_vm.$attrs.formData.advance_attribute.errorText.style)},[_vm._v("\n    "+_vm._s(scope.error)+"\n  ")])}}],null,false,822395218)},[(_vm.label)?_c('div',{staticClass:"flex",class:_vm.helpTextType ? 'align-items-center' : 'flex-direction-column',style:(_vm.labelStylePadding),attrs:{"slot":"label"},slot:"label"},[_c('span',{staticClass:"label-text mr6",style:(_vm.labelStyle)},[(_vm.$attrs.currentItem.is_required == 2)?_c('span',{style:({
            color: _vm.$attrs.formData.basic_attribute.requiredAsteriskColor
          })},[_vm._v("*\n      ")]):_vm._e(),_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),(_vm.$attrs.currentItem.helpText)?_c('span',{staticClass:"description",style:(_vm.$attrs.formData.advance_attribute.helpText.style)},[_vm._v("\n      "+_vm._s(_vm.$attrs.currentItem.helpText)+"\n    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_vm._e()},
  staticRenderFns: [],
    name: 'zqFormItem',
    props: {
      isHiddenLabel: {
        type: Boolean,
        default: false
      },
      cusProps: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {}
    },
    //监听属性 类似于data概念
    computed: {
      currentItem() {
        return this.$attrs.currentItem
      },
      label() {
        return this.isHiddenLabel ? '' : this.$attrs.currentItem.display_name
      },
      submitData() {
        return this.$attrs.submitData || {}
      },
      rules() {
        const {
          is_required,
          open_limit_data_format,
          data_format,
          custom_format_error_msg,
          extra_restrict_rule = {},
          field_type,
          lock_email_domain
        } = this.$attrs.currentItem;
        const addressRequired = this.getAddressRequired(extra_restrict_rule);
        if (addressRequired) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.$attrs.currentItem.is_required = addressRequired ? 2 : 1;
        }
        let rules$1 = [];
        rules$1.push({
          required: is_required == 2,
          validator: async (rule, value, callback) => {
            const currentItem = { ...this.$attrs.currentItem };
            if (rules[field_type]) {
              field_type === 'PhoneNumber' && this.setMobilePhone(currentItem);
              rules[field_type](value, callback, is_required, currentItem);
            } else {
              rules['Default'](value, callback, is_required, currentItem);
            }
          }
        });
        if (field_type == 'Email' && lock_email_domain == 2) {
          rules$1.push({
            validator: checkEmailDomain.bind(this),
            trigger: ['blur', 'change']
          });
        }
        if (open_limit_data_format == 2 && data_format) {
          const trimmedRegexString = data_format.slice(1, -1);
          rules$1.push({
            pattern: new RegExp(trimmedRegexString),
            message: custom_format_error_msg || '格式不正确',
            trigger: ['blur']
          });
        }
        return rules$1
      },
      labelStyle() {
        // eslint-disable-next-line no-unused-vars
        const { padding, ...styles } =
          this.$attrs.formData.advance_attribute.submitBtnText.style;
        return styles
      },
      labelStylePadding() {
        const { padding } =
          this.$attrs.formData.advance_attribute.submitBtnText.style;
        return { padding: padding }
      },
      helpTextType() {
        return this.currentItem.helpTextType == '1'
      }
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      getAddressRequired(extra_restrict_rule) {
        const { address = [] } = extra_restrict_rule || {};
        const addressKeys = ['country', 'province', 'city']; // , 'area'
        const isRequired = address.some((item) => {
          return (
            addressKeys.includes(item.field_name) &&
            item.is_required == 1 &&
            item.is_open == 1
          )
        });
        return isRequired
      },
      setMobilePhone(currentItem) {
        const { field_type, field_name, show_country_code } = currentItem;
        if (field_type === 'PhoneNumber' && show_country_code == 1) {
          if (field_name == 'MobilePhone') {
            currentItem['CountryCode'] = this.value['CountryCode'];
          } else {
            const fieldName = field_name + '_country_code';
            currentItem['CountryCode'] = this.value[fieldName];
          }
        }
      }  
    }
  };

  Vue__default["default"].prototype.closest2 = function (target) {
    let current = this;
    while (current) {
      if (current && current.$vnode && current.$vnode.tag) {
        const tagName = current.$vnode.tag.replace(/vue-component-\d+-/, '');
        if (target === tagName) {
          return current;
        } else {
          current = current.$parent;
        }
      } else {
        current = current.$parent;
      }
    }
    return null;
  };
  const IsIphonex = () => {
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      if (screen.height == 812 && screen.width == 375) {
        return true;
      } else {
        return false;
      }
    }
  };
  const copeIphoneXHomeIndicator = dom => {
    if (IsIphonex()) {
      let range = 68;
      if (!dom.oldHeight) {
        dom.oldHeight = Number(dom.style.height.replace("px", ""));
      }

      //debugger;
      dom.style.height = dom.oldHeight - range + "px";
      dom.style.paddingBottom = range + "px";
    }
  };
  const isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  const dateFormat = (fmt, date) => {
    if (!date || typeof date !== "number") return "";
    date = new Date(date * 1000);
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(),
      // 年
      "m+": (date.getMonth() + 1).toString(),
      // 月
      "d+": date.getDate().toString(),
      // 日
      "H+": date.getHours().toString(),
      // 时
      "M+": date.getMinutes().toString(),
      // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
      }
    }
    return fmt;
  };

  const mixin = {
    mounted() {
      this.hasRuleFlie();
      this.getFlieKeyArray();
    },
    data() {
      return {
        hasRuleFlieLength: 0,
        // 带规则字段的总数
        hasFlieLength: 0,
        // 带规则字段的总数
        isLasteRule: 0,
        // 最后一个规则字段的规则触发数
        flieKeyArray: [] // 所有规则字段的key的数组
      };
    },
    methods: {
      /**
       * 获取还有规则字段的数量
       * 用来判断是否是最后一个
       * 是 初始化校验状态
       * 下次校验可以不匹配可以重置
       */
      hasRuleFlie() {
        this.$attrs.formData.field_content.forEach(item => {
          if (item.tag == "panel") {
            item.editableTabs.forEach(panle => {
              if (panle.children.length > 0) {
                panle.children.forEach(panelFile => {
                  if (panelFile.fileRules.length > 0) {
                    const hasRealRule = this.hasRealRule(panelFile.fileRules);
                    hasRealRule && this.hasRuleFlieLength++;
                  }
                });
              }
            });
          } else {
            const fileRules = item.fileRules;
            if (fileRules.length > 0) {
              const hasRealRule = this.hasRealRule(fileRules);
              hasRealRule && this.hasRuleFlieLength++;
            }
          }
        });
      },
      /**
       * 获取所有规则字段的field_name
       * 用来判断当前的规则字段的索引
       */
      getFlieKeyArray() {
        this.$attrs.formData.field_content.forEach(item => {
          if (item.tag == "panel") {
            item.editableTabs.forEach(panle => {
              if (panle.children.length > 0) {
                panle.children.forEach(panelFile => {
                  if (panelFile.fileRules.length > 0) {
                    const hasRealRule = this.hasRealRule(panelFile.fileRules);
                    if (hasRealRule) {
                      this.hasFlieLength++;
                      this.flieKeyArray.push({
                        field_name: panelFile.field_name,
                        ruleLength: panelFile.fileRules.length
                      });
                    }
                  }
                });
              }
            });
          } else {
            if (item.fileRules.length > 0) {
              const hasRealRule = this.hasRealRule(item.fileRules);
              if (hasRealRule) {
                this.hasFlieLength++;
                this.flieKeyArray.push({
                  field_name: item.field_name,
                  ruleLength: item.fileRules.length
                });
              }
            }
          }
        });
      },
      /**
       * 时间转化
       * @param {*} time
       * @param {*} type
       * @returns
       */
      dateFormat,
      formatDate(date, format = 'yyyy-MM-dd') {
        if (!date) return '';
        if (!(date instanceof Date)) {
          date = new Date(date); // 确保 date 是 Date 类型
        }
        const map = {
          yyyy: date.getFullYear(),
          MM: String(date.getMonth() + 1).padStart(2, '0'),
          dd: String(date.getDate()).padStart(2, '0'),
          HH: String(date.getHours()).padStart(2, '0'),
          mm: String(date.getMinutes()).padStart(2, '0'),
          ss: String(date.getSeconds()).padStart(2, '0')
        };
        return format.replace(/yyyy|MM|dd|HH|mm|ss/g, matched => map[matched]);
      },
      /**
       * 格式化校验数据
       * @param {*} item
       * @returns
       * Text: "zqInput",
          TextArea: "zqTextarea",
          Select: "zqSelect",
          Radio: "zqRadio",
          CheckBox: "zqCheckbox",
          Number: "zqInputNumber",
          Address: "zqAddress",
          DateTime: "zqDateTimePicker",
          PhoneNumber: "MobilePhone",
          Email: "zqEmail",
       */
      initRuleValue(item) {
        let val = null;
        // 字段不存在 设置为空
        if (!this.value[item.field_name] || this.value[item.field_name] == []) {
          val = "";
        } else {
          // 地址字段转化为字符串
          if (item.tag == "zqAddress") {
            if (this.value[item.field_name].province == "" && this.value[item.field_name].address == "") {
              val = "";
            } else {
              val = this.value[item.field_name + "address"];
            }
          } else if (item.tag == "zqEmail" || item.tag == "phoneNumber") {
            // 邮箱和手机号 获取检验状态
            val = this.value[`${item.field_name}_checked`];
            // } else if (item.tag == "zqRadio") {
            //   // 单选 根据key 获取 lable
            //   let labels = item.options.filter(
            //     (option) => option.value == this.value[item.field_name]
            //   );
            //   val = labels.length > 0 ? labels[0].label : "";
            // } else if (item.tag == "zqSelect") {
            // 单选 根据key 获取 lable
            // let labels = item.options.filter(
            //   (option) => option.value == this.value[item.field_name]
            // );
            // val = labels.length > 0 ? labels[0].label : "";
          } else if (item.tag == "zqCheckbox") {
            // 单选 根据key 获取 lable 在转化为数组
            if (this.value[item.field_name].length == 0) {
              val = "";
            } else {
              val = item.options.filter(options => {
                return this.value[item.field_name].includes(options.value);
              }).map(ite => {
                return ite.label;
              }).join("");
            }
          } else if (item.tag == "zqInputNumber") {
            // 数字类型转字符串
            val = this.value[item.field_name].toString();
          } else if (item.tag == "zqDateTimePicker") {
            // 日期转化为字符串
            val = this.dateFormat(this.value[item.field_name], "YYYY-mm-dd HH:MM");
          } else {
            val = this.value[item.field_name];
          }
        }
        return val;
      },
      /**
       * 有规则值变化时遍历校验所有规则字段
       */
      checkedFlieKey() {
        this.$attrs.formData.field_content.forEach(item => {
          if (item.tag == "panel") {
            item.editableTabs.forEach(panle => {
              if (panle.children.length > 0) {
                panle.children.forEach(panelFile => {
                  if (panelFile.fileRules.length > 0) {
                    panelFile.fileRules.forEach(rule => {
                      let val = this.initRuleValue(panelFile);
                      if (item.activeValue != "" && panle.value == item.activeValue) {
                        this.ruleType(rule, val, "", panelFile.field_name, true);
                      } else {
                        this.ruleType(rule, val, "", panelFile.field_name, false);
                      }
                    });
                  }
                });
              }
            });
          } else {
            if (item.fileRules.length > 0) {
              item.fileRules.forEach(rule => {
                let val = this.initRuleValue(item);
                if (item.activeValue != "") {
                  this.ruleType(rule, val, "", item.field_name, true);
                } else {
                  this.ruleType(rule, val, "", item.field_name, false);
                }
              });
            }
          }
        });
      },
      /**
       *  规则类型区分
       * @param {*} item  字段
       * @param {*} val 输入的值
       * @param {*} isEnd  暂时不用
       * @param {*} field_name  字段的唯一标识
       * @param {*} flag  是否是激活字段
       */
      ruleType(item, val, isEnd, field_name, flag) {
        switch (item.selectValue) {
          case 1:
            this.isSuccess(item.panelRule, val, item.selectValue, isEnd, field_name, flag);
            break;
          case 2:
            this.isError(item.panelRule, val, item.selectValue, isEnd, field_name, flag);
            break;
          case 3:
            this.isEqual(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 4:
            this.isNoEqual(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 5:
            this.isLike(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 6:
            this.isNolike(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 7:
            this.isStart(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 8:
            this.isEnd(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 9:
            this.isNull(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
          case 10:
            this.isHas(item.panelRule, val, item.value, isEnd, field_name, flag);
            break;
        }
      },
      /**
       * 初始化面板状态
       * @param {*} panelIndex
       */
      initpanel(panelIndex) {
        if (!this.$attrs.formData.field_content[panelIndex]) {
          return;
        }
        this.$attrs.formData.field_content[panelIndex].editableTabs.forEach(panle => {
          // 面板是否有状态
          if (panle.children.length > 0) {
            // 有查看每个状态的字段是否配置了规则
            panle.children.forEach(panelFile => {
              // 字段是否有规则
              if (panelFile.fileRules.length > 0) {
                // 判断是否是有效的规则
                panelFile.fileRules.forEach(panelFileItem => {
                  if (panelFileItem.panelRule.length > 0) {
                    // 循环规则找出规则控制的面板
                    panelFileItem.panelRule.forEach(panelRuleItem => {
                      // 面板索引
                      let fileIndex = this.$attrs.formData.field_content.findIndex(fileIndexItem => {
                        return fileIndexItem.field_name == panelRuleItem.field_name;
                      });
                      if (fileIndex > -1) {
                        // 是否有规则命中
                        let isPanelSuccess = this.$attrs.formData.field_content[fileIndex].isSuccess;
                        // 没有隐藏面板
                        if (!isPanelSuccess) {
                          this.$attrs.formData.field_content[fileIndex].activeValue = "";
                        }
                      }
                      this.initpanel(fileIndex);
                    });
                  }
                });
              }
            });
          }
        });
      },
      /**
       * 规则匹配成功
       * @param {*} panelRule
       * @param {*} field_name
       * @returns
       */
      isRulePanel(panelRule, field_name) {
        // 获取规则面板
        let panelIndex = this.$attrs.formData.field_content.findIndex(item => {
          return item.field_name == panelRule.field_name;
        });
        // 面板的显示和隐藏的状态判断
        if (panelRule.field_value == "show") {
          // 没有激活面板状态默认显示第一个
          if (this.$attrs.formData.field_content[panelIndex].activeValue == "") {
            if (this.$attrs.formData.field_content[panelIndex].editableTabs.length > 0 && this.$attrs.formData.field_content[panelIndex].editableTabs[0].children.length > 0) {
              // let defalueRule =
              //   this.$attrs.formData.field_content[panelIndex].editableTabs[0]
              //     .value;
              this.$attrs.formData.field_content[panelIndex].isEdit = true;
              this.$attrs.formData.field_content[panelIndex].activeValue = "";
              // this.$attrs.formData.field_content[panelIndex].activeValue =
              // defalueRule;
            }
          }
          this.$attrs.formData.field_content[panelIndex].isShow = true;
          // 最后一个初始化检验状态
          if (filedIndex + 1 == this.hasRuleFlieLength) {
            // this.$attrs.formData.field_content[panelIndex].isSuccess = false;
            this.$attrs.formData.field_content.forEach((item, index) => {
              if (item.tag == "panel") {
                this.$attrs.formData.field_content[index].isSuccess = false;
              }
            });
          }
          return;
        }
        // 隐藏状态
        if (panelRule.field_value == "hidden") {
          this.$attrs.formData.field_content[panelIndex].isShow = false;
          this.$attrs.formData.field_content[panelIndex].isEdit = true;
          if (this.hasRuleFlieLength == 1) {
            this.$attrs.formData.field_content[panelIndex].isSuccess = false;
          } else {
            this.$attrs.formData.field_content[panelIndex].isSuccess = true;
          }
          // 面板值设置为空
          this.$attrs.formData.field_content[panelIndex].activeValue = "";
          // 最后一个初始化检验状态
          if (filedIndex + 1 == this.hasRuleFlieLength) {
            // this.$attrs.formData.field_content[panelIndex].isSuccess = false;
            this.$attrs.formData.field_content.forEach((item, index) => {
              if (item.tag == "panel") {
                this.$attrs.formData.field_content[index].isSuccess = false;
              }
            });
          }
          return;
        }
        if (panelIndex > -1) {
          // 匹配上显示项设为true
          this.$attrs.formData.field_content[panelIndex].isShow = true;
          this.$attrs.formData.field_content[panelIndex].isEdit = true;
          this.$attrs.formData.field_content[panelIndex].isSuccess = true;
          // 设置面板的激活状态值
          this.$attrs.formData.field_content[panelIndex].activeValue = panelRule.field_value;
        }
        let filedIndex = this.flieKeyArray.findIndex(item => {
          return item.field_name == field_name;
        });
        // 最后一个初始化检验状态
        // this.hasFlieLength 所有的规则字段总数
        // filedIndex + 1 当前字段的索引
        if (filedIndex + 1 == this.hasFlieLength) {
          // 记录最后一个字段的规则触发次数 来判断是否是最后一个规则
          this.isLasteRule++;
          // 是最后的规则
          if (this.isLasteRule == (this.flieKeyArray[filedIndex] && this.flieKeyArray[filedIndex].ruleLength)) {
            // 是最后一次则规则检验完成 计数清零
            this.isLasteRule = 0;
            //重置所有面板的检验成功的状态 isSuccess
            this.$attrs.formData.field_content.forEach((item, index) => {
              if (item.tag == "panel") {
                this.$attrs.formData.field_content[index].isSuccess = false;
              }
            });
          }
        }
      },
      /**
       * 规则触发 没有匹配
       * 根据面板时候被其他字段激活 isSuccess = true 激活
       * 激活 不改变面板状态
       * 没激活 面板状态设置为空
       * 如果是最后一个字段中是最后一个规则 则重置面板 isSuccess的状态 不然会影响下轮的检验
       * @param {*} panelRule
       * @param {*} val
       * @param {*} isEnd
       * @param {*} field_name
       */
      isNoRulePanel(panelRule, val, isEnd, field_name) {
        // 找到触发规则的字段的索引 判断是否是最后一个

        let filedIndex = this.flieKeyArray.findIndex(item => {
          return item.field_name == field_name;
        });

        // 找到规则控制面板的索引
        let panelIndex = this.$attrs.formData.field_content.findIndex(item => {
          return item.field_name == panelRule.field_name;
        });
        if (panelIndex >= 0) {
          // 获取面板面板的激活状态
          let isSuccess = this.$attrs.formData.field_content[panelIndex].isSuccess;
          // 未激活则隐藏面板 激活的面板不操作 使用上次激活的面板状态
          if (!isSuccess) {
            this.$attrs.formData.field_content[panelIndex].isShow = true;
            this.$attrs.formData.field_content[panelIndex].activeValue = "",
            // 查看当前面板的个状态的字段是否有控制的面板
            // 做面板的字段规则失效 隐藏面板字段控制的面板
            this.initpanel(panelIndex);
          }
        }
        // 最后一个初始化检验状态
        // this.hasFlieLength 所有的规则字段总数
        // filedIndex + 1 当前字段的索引
        if (filedIndex + 1 == this.hasFlieLength) {
          // 记录最后一个字段的规则触发次数 来判断是否是最后一个规则
          this.isLasteRule++;
          // 是最后的规则
          if (this.isLasteRule == (this.flieKeyArray[filedIndex] && this.flieKeyArray[filedIndex].ruleLength)) {
            // 是最后一次则规则检验完成 计数清零
            this.isLasteRule = 0;
            //重置所有面板的检验成功的状态 isSuccess
            this.$attrs.formData.field_content.forEach((item, index) => {
              if (item.tag == "panel") {
                this.$attrs.formData.field_content[index].isSuccess = false;
              }
            });
          }
        }
      },
      /**
       * 正确
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isSuccess(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (ruleValue == val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 不正确
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isError(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (ruleValue == val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 等于
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isEqual(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          console.log(item);
          // ruleValue == item.field_value && flag
          if (ruleValue == val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 不等于
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isNoEqual(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (ruleValue != val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 包含
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isLike(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (val && val.indexOf(ruleValue) > -1 && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 不包含
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isNolike(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (val && val.indexOf(ruleValue) == -1 && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 开头匹配
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isStart(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (val && val.startsWith(ruleValue) && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 结尾匹配
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isEnd(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (val && val.endsWith(ruleValue) && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 为空
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isNull(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (!val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 不为空
       * @param {*} panelRules 触发的规则面板
       * @param {*} val  输入的值
       * @param {*} ruleValue  设置的值
       * @param {*} isEnd 暂时不用了
       * @param {*} field_name 字段值 为了查找字段的索引判断是否是最后一个规则字段
       * @param {*} flag 是否是激活字段
       * @returns
       */
      isHas(panelRules, val, ruleValue, isEnd, field_name, flag) {
        if (panelRules.length == 0) {
          return;
        }
        panelRules.forEach(item => {
          if (val && flag) {
            this.isRulePanel(item, field_name);
          } else {
            this.isNoRulePanel(item, val, isEnd, field_name);
          }
        });
      },
      /**
       * 避免字段添加了规则   但是什么都没填写
       * @param {*} fileRules 
       * @returns 
       */
      hasRealRule(fileRules) {
        const hasRealRule = fileRules.some(field => field.panelRule.some(rule => rule.field_name !== ''));
        return hasRealRule;
      }
    }
  };

  const btnTheme = formData => {
    if (formData.theme_setting === "normal") {
      return {
        borderRadius: "4px",
        borderWidth: "1px",
        borderColor: formData.advance_attribute.input.style.borderColor
      };
    } else if (formData.theme_setting === "line") {
      return {
        borderRadius: "4px",
        borderWidth: "1px",
        borderColor: formData.advance_attribute.input.style.borderColor
      };
    } else {
      return {
        borderRadius: "20px",
        borderWidth: "1px",
        borderColor: formData.advance_attribute.input.style.borderColor
      };
    }
  };

  const service = axios__default["default"].create({
    timeout: 6000000
  });
  service.interceptors.request.use(config => {
    return config;
  }, error => {
    console.log(error);
    return Promise.reject(error);
  });
  service.interceptors.response.use(res => {
    if (res.data.code === 2) {
      window.location.href = "/login";
      return Promise.reject(new Error(res.data.msg || "Error"));
    } else if (res.data.code === -2) {
      window.location.href = "/404";
      return Promise.reject(new Error(res.data.msg || "Error"));
    } else if (res.data.code === 3) {
      alert("无权限，请联系系统管理员修改权限设置");
      return Promise.reject(new Error(res.data.msg || "Error"));
    } else if (res.data.code === 12030) {
      let timesRun = 10;
      let interval = setInterval(function () {
        timesRun--;
        document.querySelector("#timesRun").innerText = timesRun + "s";
        if (timesRun <= 0) {
          clearInterval(interval);
          document.querySelector(".logout-btn").click();
        }
      }, 1000);
      clearInterval(interval);
      window.location.href = "/login";
      return Promise.reject(new Error(res.msg || "Error"));
    } else if (res.data.code === 12033) {
      window.location.href = "/login";
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return Promise.resolve(res.data);
    }
  }, error => {
    console.log("err" + error);
    return Promise.reject(error);
  });

  var phoneNumber = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phoneNumber-341423"},[_c('div',{staticClass:"flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[[_c('el-input',{staticClass:"input-with-select",class:{ 'has-select': _vm.show_country_code == 1 },style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.placeholder || '请输入'},on:{"blur":_vm.phoneChange},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name]"}},[(_vm.show_country_code == 1)?_c('zq-select',{staticStyle:{"width":"100%"},attrs:{"slot":"prepend","options":_vm.countryCodeOptions,"optionsField":{
                label: 'value',
                value: 'value'
              },"canSearch":true,"placeholder":"请选择"},slot:"prepend",model:{value:(_vm.countryCode),callback:function ($$v) {_vm.countryCode=$$v;},expression:"countryCode"}}):_vm._e()],1)]],2),_vm._v(" "),(_vm.$attrs.currentItem.isVerificationCode == 2)?_c('div',{staticClass:"mb24"}):_vm._e(),_vm._v(" "),(_vm.$attrs.currentItem.isVerificationCode == 2)?_c('el-form-item',_vm._b({attrs:{"isHiddenLabel":true,"prop":_vm.$attrs.currentItem.field_name + 'code',"rules":[
          {
            required: true,
            message: _vm.$attrs.currentItem.code_validate_error_msg || '此为必填项',
            trigger: ['blur', 'change']
          }
        ]},scopedSlots:_vm._u([{key:"error",fn:function(scope){return _c('span',{staticClass:"el-form-item__error",style:(_vm.$attrs.formData.advance_attribute.errorText.style)},[_vm._v("\n        "+_vm._s(scope.error)+"\n      ")])}}],null,false,1267446354)},'el-form-item',_vm.$attrs,false),[_c('div',{staticClass:"code-row"},[_c('zq-input',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"maxlength":4,"placeholder":_vm.$attrs.currentItem.code_placeholder || '请输入'},on:{"input":_vm.codeInputBlur},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name + 'code']),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name + 'code', (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name + 'code']"}}),_vm._v(" "),_c('zq-button',{staticClass:"code-btn",style:(_vm.$attrs.formData.advance_attribute.submitBtn.style),attrs:{"disabled":!_vm.value[_vm.$attrs.currentItem.field_name] || _vm.btnDisabled},on:{"click":_vm.sendCode}},[_c('span',{style:(_vm.$attrs.formData.basic_attribute.submitBtnText.style)},[_vm._v(" "+_vm._s(_vm.countdown > 0 ? _vm.codeBtnText : _vm.$attrs.currentItem.code_btn_text || '获取验证码'))])])],1)]):_vm._e()],1)])},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    name: 'phoneNumber',
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {
        code: '',
        codeBtnText: '获取验证码',
        countdown: 0,
        btnDisabled: false,
        checkedStatus: '',
        checkedPhone: '',
        countryCodeOptions: []
      }
    },
    //监听属性 类似于data概念
    computed: {
      currentItem() {
        return this.$attrs.currentItem
      },
      show_country_code() {
        return this.currentItem.show_country_code
      },
      fieldName() {
        return this.currentItem.field_name
      },
      fieldCountryCode() {
        return this.fieldName + '_country_code'
      },
      countryCode: {
        get() {
          const { default_country_code } = this.currentItem;
          if (this.fieldName == 'MobilePhone') {
            const CountryCode = this.value['CountryCode'];
            !CountryCode &&
              this.$set(this.value, 'CountryCode', default_country_code);
            return this.value['CountryCode']
          }

          const country_code = this.value[this.fieldCountryCode];
          !country_code &&
            this.$set(this.value, this.fieldCountryCode, default_country_code);
          return this.value[this.fieldCountryCode]
        },
        set(val) {
          const fieldName =
            this.fieldName == 'MobilePhone'
              ? 'CountryCode'
              : this.fieldCountryCode;
          this.$set(this.value, fieldName, val);
        }
      }
    },
    //监控data中的数据变化
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
          // this.value['CountryCode'] = this.value['CountryCode'] || (this.$set(this.value,'CountryCode','86'))
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      if (this.show_country_code == 1) {
        this.getCountryAreaCode();
      }
    },
    //方法集合
    methods: {
      btnTheme,
      sendCode() {
        let mobile_type = undefined;
        if(this.show_country_code == 1){
          if (this.fieldName == 'MobilePhone') {
            mobile_type = this.value['CountryCode'];
          }else {
            mobile_type = this.value[this.fieldCountryCode];
          }
        }
        const params = {
          mobile_type: mobile_type || undefined,
          value: this.value[this.$attrs.currentItem.field_name],
          org_id: this.$attrs.formData.org_id,
          form_id: this.$attrs.formData.id
        };
        service({
          url: this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/get-code',
          method: 'post',
          data: params
        }).then(({ code, msg }) => {
          if (code == 0) {
            let timesRun = 90;
            this.btnDisabled = true;
            this.phoneCode = this.value;
            let interval = setInterval( ()=> {
              timesRun--;
              this.codeBtnText = `${timesRun}s`;
              if (timesRun === 0) {
                this.btnDisabled = false;
                this.codeBtnText = '重新获取';
                clearInterval(interval);
              }
              this.countdown = timesRun;
            }, 1000);
          } else {
            this.$zqMessage.error(msg);
          }
        });
      },
      codeChange(val) {
        if (val.length >= 4) {
          this.codeInputBlur();
        }
      },
      phoneChange(val) {
        if (this.checkedStatus && val == this.checkedPhone) {
          // this.isSuccess();
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            1
          );
          this.checkedFlieKey();
          this.checkedStatus = 1;
        } else if (this.checkedStatus && val != this.checkedPhone) {
          // this.isError();
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            2
          );
          this.checkedFlieKey();
          this.checkedStatus = 2;
        }
      },
      codeInputBlur(val) {
        if (val && val.length !== 4) {
          this.checkedStatus = 2;
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            2
          );
          this.checkedFlieKey();
          return
        }
        const params = {
          value: this.value[this.$attrs.currentItem.field_name],
          code: this.value[this.$attrs.currentItem.field_name + 'code']
        };
        service({
          url: this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/check-code',
          method: 'post',
          data: params
        }).then(({ code }) => {
          if (code == 0) {
            this.$emit('checked', this.$attrs.currentItem.field_name);
            this.checkedStatus = 1;
            // this.isSuccess();
            this.$set(
              this.value,
              `${this.$attrs.currentItem.field_name}_checked`,
              1
            );
            this.checkedFlieKey();
            this.checkedPhone = this.value[this.$attrs.currentItem.field_name];
            // this.$zqMessage.success(msg);
          } else {
            this.checkedStatus = 2;
            // this.isError();
            this.$set(
              this.value,
              `${this.$attrs.currentItem.field_name}_checked`,
              2
            );
            this.checkedFlieKey();
            // this.$zqMessage.error(msg);
          }
        });
      },
      // 获取国家区号
      getCountryAreaCode() {
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix +
            'system/user/get-mobile-type-by-orgid',
          method: 'post',
          data: {
            org_id: this.$attrs.formData.org_id
          }
        }).then(({ code, data, msg }) => {
          if (code == 0) {
            this.countryCodeOptions = data;
          } else {
            this.$zqMessage.error(msg);
          }
        });
      }
    }
  };

  var zqInput = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-input-field"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zq-text-field',{staticClass:"input-with-select",attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请输入',"styles":_vm.$attrs.formData.advance_attribute.input.style},on:{"blur":_vm.handlerChange},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, $$v);},expression:"value[$attrs.currentItem.field_name]"}})],1)],1)},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用

    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      //这里存放数据
      return {}
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {},
    //方法集合
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      },
    },
  };

  Vue__default["default"].prototype.closest = function (target) {
    target = target.replace(/^\w/, match => {
      return match.toUpperCase();
    });
    let current = this;
    while (current) {
      if (current && current.$vnode && current.$vnode.tag) {
        const tagName = current.$vnode.tag.replace(/vue-component-\d+-/, '');
        if (target === tagName) {
          return current;
        } else {
          current = current.$parent;
        }
      } else {
        current = current.$parent;
      }
    }
    return null;
  };
  function isNode(component, targetName) {
    const tagName = component.$vnode.tag.replace(/vue-component-\d+-/, '');
    if (targetName === tagName) {
      return true;
    } else {
      return false;
    }
  }
  function walk(current, target, res) {
    if (isNode(current, target)) {
      res.push(current);
    }
    if (current.$children && current.$children.length) {
      current.$children.forEach(item => {
        walk(item, target, res);
      });
    }
  }
  Vue__default["default"].prototype.find = function (target) {
    target = target.replace(/^\w/, match => {
      return match.toUpperCase();
    });
    const res = [];
    walk(this, target, res);
    return res;
  };

  // 组件管理器
  class ComponentStore {
    constructor() {
      this.modules = {};
    }
    static getInstance() {
      if (!this.instance) {
        this.instance = new ComponentStore();
      }
      return this.instance;
    }

    // 通过id 获取组件
    getById(id) {
      if (this.isExist(id)) {
        return this.modules[id];
      } else {
        return null;
      }
    }

    // 给组件设置id
    set(id, component) {
      if (this.isExist(id)) {
        console.error('组件id名' + id + '重复');
        return;
      }

      // 给组件加入id 属性
      component.selfId = id;
      this.modules[id] = component;

      // 注入子应用（用于调试）
      component.$sdk && component.$sdk.setSubAppCase(this.modules, id);
    }

    // 通过id 清除组件
    clear(id) {
      if (!this.isExist(id)) {
        return;
      }
      this.modules[id] = null;
      delete this.modules[id];
    }
    // 判断组件是否存在
    isExist(id) {
      return !!this.modules[id];
    }
  }
  const componentStoreCase = ComponentStore.getInstance();

  var moibleSelect = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobileSelectWrap"},[_c('van-field',{staticClass:"zq-select input-with-select",style:(_vm.style1),attrs:{"readonly":"","clickable":"","name":"picker","right-icon":"icon el-icon-arrow-up","placeholder":_vm.placeholder,"value":_vm.currentLabel},on:{"click":_vm.showVanPicker}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v;},expression:"showPicker"}},[_c('flexBox',{staticClass:"van-picker"},[_c('div',{staticClass:"van-picker__toolbar",attrs:{"slot":"head"},slot:"head"},[_c('button',{staticClass:"van-picker__cancel",attrs:{"type":"button"},on:{"click":_vm.closePop}},[_vm._v("\n          取消\n        ")]),_vm._v(" "),_c('div',{staticClass:"van-ellipsis van-picker__title"},[_vm._v("下拉框选择")]),_vm._v(" "),_c('button',{staticClass:"van-picker__confirm",attrs:{"type":"button","disabled":_vm.currentSelect === -1},on:{"click":_vm.confirmFn}},[_vm._v("\n          确认\n        ")])]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ul',{staticStyle:{"height":"196px","padding-bottom":"68px","margin-left":"0px !important","list-style":"none !important"}},_vm._l((_vm.data),function(item,index){return _c('li',{key:index,class:{
                selectItem: true,
                selected: index === _vm.currentSelect,
              },on:{"click":function () {
                  _vm.selectFn(index);
                }}},[_c('div',{staticClass:"van-ellipsis"},[_vm._v(_vm._s(item.label))])])}),0)])])],1)],1)},
  staticRenderFns: [],
    name: "mobileSelect",
    data() {
      return {
        showPicker: false,
        currentSelect: -1,
      };
    },
    computed: {
      currentLabel() {
        let res = this.data.filter((item) => {
          return item.value === this.value;
        })[0];
        if (res) {
          return res.label;
        } else {
          return "";
        }
      },
    },
    components: {
      flexBox,
    },
    props: {
      value: {
        type: String,
        default() {
          return "";
        },
      },
      style1: {
        type: Object,
        default() {
          return {};
        },
      },
      placeholder: {
        type: String,
        default() {
          return "";
        },
      },
      data: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      showVanPicker() {
        this.showPicker = true;

        let currentSelect = -1;
        this.data.forEach((item, index) => {
          if (item.value === this.value) {
            currentSelect = index;
          }
        });
        this.currentSelect = currentSelect;
        this.$nextTick(() => {
          let dom = this.$el.querySelector(".flexBoxWrap");
          copeIphoneXHomeIndicator(dom);
        });
        this.$emit("showPicker", true);
      },
      selectFn(index) {
        this.currentSelect = index;
        this.$emit("change");
      },
      closePop() {
        this.showPicker = false;
      },
      confirmFn() {
        this.closePop();
        this.$emit("confirm", this.data[this.currentSelect]);
      },
    },
  };

  var zqSelect = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-select-2432414243"},[_c('div',{staticClass:"flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[[_c('zq-select',{ref:"agentSelect",staticClass:"input-with-select",style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.placeholder,"options":_vm.options,"multiple":_vm.currentItem.multiple,"canSearch":_vm.options.length > 10,"defaultFocus":false,"popperClass":"zq-npm-select-form-popper"},on:{"change":_vm.handlerChange,"visible-change":_vm.visibleChange},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v;},expression:"selectedValue"}})]],2)],1)])},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    components: { zqFormItem, moibleSelect },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {
        isMobile: false,
        defaultIndex: 0,
        showPicker: false,
        fetchOptions: this.$attrs.currentItem.options || []
      }
    },
    //监听属性 类似于data概念
    computed: {
      options() {
        return this.fetchOptions.filter(
          (item) =>
            !Object.prototype.hasOwnProperty.call(item, 'isShow') || item.isShow
        )
      },
      selectedValue: {
        get() {
          const multiple = this.currentItem.multiple;
          const value = this.value[this.$attrs.currentItem.field_name];
          return multiple
            ? Array.isArray(value)
              ? value
              : value
              ? [value]
              : []
            : value || ''
        },
        set(value) {
          this.$set(this.$attrs.currentItem, 'default_value', value);
          this.$set(this.value, this.$attrs.currentItem.field_name, value);
        }
      },
      orgId() {
        return this.closest2('ZqFormPage').params.org_id || ''
      },
      formId() {
        return this.closest2('ZqFormPage').params.form_id || ''
      },
      fieldContent() {
        return this.$attrs.formData.field_content
      },
      currentItem() {
        return this.$attrs.currentItem
      }
    },
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.isMobile = false;
      componentStoreCase.set('zqSelect', this);
    },
    beforeDestroy() {
      componentStoreCase.clear('zqSelect');
    },
    //方法集合
    methods: {
      showVanPicker() {
        this.showPicker = true;
      },
      onConfirm(value) {
        this.$set(this.$attrs.currentItem, 'default_value', value.value);
        this.$set(this.value, this.$attrs.currentItem.field_name, value.value);
        this.showPicker = false;

        this.resetCommon();
      },
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
        if (!this.isMobile) {
          this.resetCommon();
        }
      },
      resetCommon() {
        const dependChildIds = this.getDependChildIds(this.currentItem);
        if (dependChildIds.length <= 0) return
        let fieldContent = this.fieldContent;
        const { in_panel, id } = this.currentItem;
        if (in_panel == 1) {
          const filterPanel = fieldContent.filter(
            (item) => item.field_type == 'panel'
          );
          fieldContent = this.findPanelChildrenById(filterPanel, id);
        }
        this.resetSelectedVal(dependChildIds, fieldContent);
      },
      // 切换控制字段时 重置依赖选择的value
      resetSelectedVal(dependChildIds, fieldContent) {
        fieldContent.forEach((item) => {
          if (
            dependChildIds.includes(item.id) &&
            item.open_depend_status == 2 &&
            item.isHidden == 1
          ) {
            this.setVal(item, '');
            const ids = this.getDependChildIds(item);
            ids.length > 0 && this.resetSelectedVal(ids, fieldContent);
          }
        });
      },
      setVal(item, val) {
        this.$set(item, 'default_value', val);
        this.$set(this.value, item.field_name, val);
      },
      // 获取当前字段的 依赖id
      getDependChildIds(item) {
        const dependChild = item.depend_child || [];
        const dependChildIds = dependChild.map((item) => item.id);
        return dependChildIds || []
      },
      visibleChange(val) {
        const { open_depend_status } = this.$attrs.currentItem;
        if (!val || open_depend_status != 2) return
        this.loading = true;
        this.fetchOptions = [];
        this.getDependFieldOption();
      },
      // 获取依赖选项值
      async getDependFieldOption() {
        const { id, depend_parent, isHidden, in_panel } = this.$attrs.currentItem;
        const controlFieldId = depend_parent[0] ? depend_parent[0].id : undefined;
        const controlFieldData = this.getCurrentFieldControlFieldSelectValue(
          controlFieldId,
          in_panel == 1
        );
        const fieldValue =
          controlFieldData && isHidden == 1
            ? this.value[controlFieldData.field_name]
            : undefined;
        const params = {
          field_id: controlFieldId, // 控制字段
          depend_field_id: id, // 当前字段
          value: fieldValue,
          form_id: this.formId,
          org_id: this.orgId
        };
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix +
            'cdp/schema-field-depend/get-depend-field-option',
          method: 'post',
          data: params
        }).then(({ code, data }) => {
          if (code == 0) {
            this.fetchOptions = data;
          }
          this.loading = false;
        });
      },
      // 获取当前字段的 控制字段的选项值
      getCurrentFieldControlFieldSelectValue(controlFieldId, in_panel) {
        let fieldContent = this.$attrs.formData.field_content;
        if (in_panel) {
          const filterPanel = fieldContent.filter(
            (item) => item.field_type == 'panel'
          );
          fieldContent = this.findPanelChildrenById(filterPanel, controlFieldId);
        }
        return fieldContent.find((item) => item.id == controlFieldId)
      },
      // 递归查找面板的children
      findPanelChildrenById(data, currentFieldId) {
        const result = data
          .flatMap((parent) => parent.editableTabs) // 展平 editableTabs 数组
          .find((subTab) =>
            subTab.children.some((child) => child.id === currentFieldId)
          );
        return result.children || []
      },
    }
  };

  var zqTextarea = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-textarea"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zq-text-field',{staticClass:"input-with-select",style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请输入',"type":"textarea"},on:{"blur":_vm.handlerChange},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name]"}})],1)],1)},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用

    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      //这里存放数据
      return {}
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {},
    //方法集合
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      },
    },
  };

  var zqRadio = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-radio"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('el-radio-group',{class:{ 'grid-wapper': _vm.currentItem.option_flat_style == 2 },style:(_vm.styles),model:{value:(_vm.selectedLabel),callback:function ($$v) {_vm.selectedLabel=$$v;},expression:"selectedLabel"}},_vm._l((_vm.options),function(item){return _c('zq-radio',{key:item.value,attrs:{"label":item.value,"checked":item.isShow},on:{"change":_vm.handlerChange}},[_vm._v(_vm._s(item.label))])}),1)],1)],1)},
  staticRenderFns: [],
    mixins: [mixin],
    components: { zqFormItem },
    inheritAttrs: false,
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {}
    },
    //监听属性 类似于data概念
    computed: {
      isMobile() {
        return isMobile();
      },
      currentItem() {
        return this.$attrs.currentItem
      },
      options() {
        return this.$attrs.currentItem.options.filter(
          (item) =>
            !Object.prototype.hasOwnProperty.call(item, 'isShow') || item.isShow
        )
      },
      selectedLabel: {
        get() {
          //return this.$attrs.currentItem.default_value;
          return this.value[this.$attrs.currentItem.field_name]
        },
        set(value) {
          // this.$set(this.$attrs.currentItem, "default_value", value);
          this.$set(this.value, this.$attrs.currentItem.field_name, value);
        }
      },
      fieldContent() {
        return this.$attrs.formData.field_content
      },
      styles() {
        if (this.currentItem.option_flat_style != 2) return {}

        if (this.isMobile) {
          const num = this.currentItem.option_flat_num_mobile;
          return {
            'grid-template-columns': `repeat(${num}, calc(${100 / num}% - 10px))`
          }
        } else {
          const num = this.currentItem.option_flat_num_pc;
          return {
            'grid-template-columns': `repeat(${num}, calc(${100 / num}% - 10px))`
          }
        }
      }
    },
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {},
    //方法集合
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
        this.resetCommon();
      },
      resetCommon() {
        const dependChildIds = this.getDependChildIds(this.currentItem);
        if (dependChildIds.length <= 0) return
        let fieldContent = this.fieldContent;
        const { in_panel, id } = this.currentItem;
        if (in_panel == 1) {
          const filterPanel = fieldContent.filter(
            (item) => item.field_type == 'panel'
          );
          fieldContent = this.findPanelChildrenById(filterPanel, id);
        }
        this.resetSelectedVal(dependChildIds, fieldContent);
      },
      // 切换控制字段时 重置依赖选择的value
      resetSelectedVal(dependChildIds, fieldContent = []) {
        fieldContent.forEach((item) => {
          if (
            dependChildIds.includes(item.id) &&
            item.open_depend_status == 2 &&
            item.isHidden == 1
          ) {
            this.setVal(item, '');
            const ids = this.getDependChildIds(item);
            ids.length > 0 && this.resetSelectedVal(ids, fieldContent);
          }
        });
      },
      // 递归查找面板
      findPanelChildrenById(data, currentFieldId) {
        const result = data
          .flatMap((parent) => parent.editableTabs) // 展平 editableTabs 数组
          .find((subTab) =>
              subTab.children.some((child) => child.id === currentFieldId)
            );
          return result.children || []
      },
      // 获取当前字段的 依赖id
      getDependChildIds(item) {
        const dependChild = item.depend_child || [];
        const dependChildIds = dependChild.map((item) => item.id);
        return dependChildIds || []
      },
      setVal(item, val) {
        this.$set(item, 'default_value', val);
        this.$set(this.value, item.field_name, val);
      }
    }
  };

  var zqCheckbox = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-checkbox"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('el-checkbox-group',{staticClass:"checkbox-group",class:{ 'grid-wapper': _vm.currentItem.option_flat_style == 2 },style:(_vm.styles),on:{"change":_vm.handlerChange},model:{value:(_vm.checkeds),callback:function ($$v) {_vm.checkeds=$$v;},expression:"checkeds"}},_vm._l((_vm.options),function(item){return _c('el-checkbox',{key:item.value,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1)],1)},
  staticRenderFns: [],
    mixins: [mixin],

    components: { zqFormItem },

    inheritAttrs: false,

    props: {
      value: {
        type: Object,
        default: () => {
          return {};
        },
      }
    },
    data() {
      //这里存放数据
      return {};
    },
    //监听属性 类似于data概念
    computed: {
      isMobile() {
        return isMobile();
      },
      currentItem() {
        return this.$attrs.currentItem;
      },
      checkeds: {
        get() {
          return this.value[this.$attrs.currentItem.field_name] || [];
        },
        set(value) {
          this.$set(this.value, this.$attrs.currentItem.field_name, value);
        },
      },
      options() {
        return this.$attrs.currentItem.options.filter(
          (item) =>
            !Object.prototype.hasOwnProperty.call(item, "isShow") || item.isShow
        );
      },
      fieldContent() {
        return this.$attrs.formData.field_content;
      },
      styles() {
        if (this.currentItem.option_flat_style != 2) return {};

        if (this.isMobile) {
          const num = this.currentItem.option_flat_num_mobile;
          return {
            "grid-template-columns": `repeat(${num}, calc(${100 / num}% - 10px))`,
          };
        } else {
          const num = this.currentItem.option_flat_num_pc;
          return {
            "grid-template-columns": `repeat(${num}, calc(${100 / num}% - 10px))`,
          };
        }
      },
    },
    watch: {},

    mounted() {},
    //方法集合
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
        this.resetCommon();
      },
      resetCommon() {
        const dependChildIds = this.getDependChildIds(this.currentItem);
        if (dependChildIds.length <= 0) return;
        let fieldContent = this.fieldContent;
        const { in_panel, id } = this.currentItem;
        if (in_panel == 1) {
          const filterPanel = fieldContent.filter(
            (item) => item.field_type == "panel"
          );
          fieldContent = this.findPanelChildrenById(filterPanel, id);
        }
        this.resetSelectedVal(dependChildIds, fieldContent);
      },
      // 切换控制字段时 重置依赖选择的value
      resetSelectedVal(dependChildIds, fieldContent = []) {
        fieldContent.forEach((item) => {
          if (
            dependChildIds.includes(item.id) &&
            item.open_depend_status == 2 &&
            item.isHidden == 1
          ) {
            this.setVal(item, "");
            const ids = this.getDependChildIds(item);
            ids.length > 0 && this.resetSelectedVal(ids, fieldContent);
          }
        });
      },
      // 递归查找面板
      findPanelChildrenById(data, currentFieldId) {
        const result = data
          .flatMap((parent) => parent.editableTabs) // 展平 editableTabs 数组
          .find((subTab) =>
              subTab.children.some((child) => child.id === currentFieldId)
            );
          return result.children || []
      },
      // 获取当前字段的 依赖id
      getDependChildIds(item) {
        const dependChild = item.depend_child || [];
        const dependChildIds = dependChild.map((item) => item.id);
        return dependChildIds || [];
      },
      setVal(item, val) {
        this.$set(item, "default_value", val);
        this.$set(this.value, item.field_name, val);
      },
    },
  };

  var zqInputNumber = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-number-field"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zq-number-field',{attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请输入',"styles":_vm.$attrs.formData.advance_attribute.input.style},on:{"change":_vm.handlerChange},model:{value:(_vm.default_value),callback:function ($$v) {_vm.default_value=$$v;},expression:"default_value"}})],1)],1)},
  staticRenderFns: [],
    mixins: [mixin],

    components: { zqFormItem },

    inheritAttrs: false,

    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    computed: {
      default_value: {
        get() {
          let value = this.value[this.$attrs.currentItem.field_name];
          return typeof value === 'number' ? value : undefined // 默认值为空  须设置为undefined
        },
        set(val) {
          this.$set(
            this.value,
            this.$attrs.currentItem.field_name,
            typeof val === 'number' ? val : ''
          );
        }
      }
    },
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      }
    }
  };

  var zqEmail = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zqEmail-124143"},[_c('div',{staticClass:"flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[[_c('zq-input',{staticClass:"input-with-select",style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.placeholder},on:{"blur":_vm.emailChange},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name]"}})]],2),_vm._v(" "),(_vm.$attrs.currentItem.isVerificationCode == 2)?_c('div',{staticClass:"mb24"}):_vm._e(),_vm._v(" "),(_vm.$attrs.currentItem.isVerificationCode == 2)?_c('el-form-item',_vm._b({attrs:{"isHiddenLabel":true,"prop":_vm.$attrs.currentItem.field_name + 'code',"rules":[
        {
          required: true,
          message: _vm.$attrs.currentItem.code_validate_error_msg || '此为必填项',
          trigger: ['blur', 'change']
        }
      ]},scopedSlots:_vm._u([{key:"error",fn:function(scope){return _c('span',{staticClass:"el-form-item__error",style:(_vm.$attrs.formData.advance_attribute.errorText.style)},[_vm._v("\n        "+_vm._s(scope.error)+"\n      ")])}}],null,false,1267446354)},'el-form-item',_vm.$attrs,false),[_c('div',{staticClass:"code-row"},[_c('zq-input',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.code_placeholder || '请输入'},on:{"input":_vm.codeInputBlur},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name + 'code']),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name + 'code', (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name + 'code']"}}),_vm._v(" "),_c('zq-button',{staticClass:"code-btn",style:(_vm.$attrs.formData.advance_attribute.submitBtn.style),attrs:{"disabled":!_vm.value[_vm.$attrs.currentItem.field_name] || _vm.btnDisabled},on:{"click":_vm.sendCode}},[_c('span',{style:(_vm.$attrs.formData.basic_attribute.submitBtnText.style)},[_vm._v(_vm._s(_vm.$attrs.currentItem.code_btn_text || _vm.codeBtnText))])])],1)]):_vm._e()],1)])},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    name: 'zqEmail',
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {
        code: '',
        codeBtnText: '获取验证码',
        btnDisabled: false,
        checkedStatus: '',
        checkedPhone: ''
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      code(val) {
        if (val.length >= 4) {
          this.codeInputBlur();
        }
      },
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
        immediate: true
      }
      // value: {
      //   handler() {
      //     console.log(this.$attrs.currentItem.display_name);
      //     let fileRules = this.$attrs.currentItem.fileRules;
      //     if (fileRules.length > 0) {
      //       this.isSuccess();
      //       this.isError();
      //     }
      //   },
      //   deep: true,
      // },
      // checkedStatus: {
      //   handler(val) {
      //     if (val == 1) {
      //       this.isSuccess();
      //     } else if (val == 2) {
      //       this.isError();
      //     }
      //   },
      // },
    },
    mounted() {},
    //方法集合
    methods: {
      btnTheme,
      sendCode() {
        let self = this;
        const params = {
          value: this.value[this.$attrs.currentItem.field_name],
          org_id: this.$attrs.formData.org_id,
          form_id: this.$attrs.formData.id
        };
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/get-email-code',
          method: 'post',
          data: params
        }).then(({ code, msg }) => {
          if (code == 0) {
            let timesRun = 90;
            this.btnDisabled = true;
            this.phoneCode = this.value;
            let interval = setInterval(function () {
              timesRun--;
              self.codeBtnText = `${timesRun}s`;
              if (timesRun === 0) {
                self.btnDisabled = false;
                self.codeBtnText = '重新获取';
                clearInterval(interval);
              }
            }, 1000);
          } else {
            this.$zqMessage.error(msg);
          }
        });
      },
      emailChange(val) {
        if (this.checkedStatus && val == this.checkedPhone) {
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            1
          );
          this.checkedFlieKey();
          this.checkedStatus = 1;
        } else if (this.checkedStatus && val != this.checkedPhone) {
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            2
          );
          this.checkedFlieKey();
          this.checkedStatus = 2;
        }
      },
      codeInputBlur(val) {
        if (val && val.length !== 4) {
          this.checkedStatus = 2;
          this.$set(
            this.value,
            `${this.$attrs.currentItem.field_name}_checked`,
            2
          );
          this.checkedFlieKey();
          return
        }
        const params = {
          value: this.value[this.$attrs.currentItem.field_name],
          code: this.value[this.$attrs.currentItem.field_name + 'code']
        };
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix +
            'cdp/form-app/check-email-code',
          method: 'post',
          data: params
        }).then(({ code, msg }) => {
          if (code == 0) {
            this.$emit('checked', this.$attrs.currentItem.field_name);
            this.$set(
              this.value,
              `${this.$attrs.currentItem.field_name}_checked`,
              1
            );
            this.checkedFlieKey();
            this.checkedStatus = 1;
            this.checkedPhone = this.value[this.$attrs.currentItem.field_name];
            this.$zqMessage.success(msg);
          } else {
            // this.isError();
            this.$set(
              this.value,
              `${this.$attrs.currentItem.field_name}_checked`,
              2
            );
            this.checkedFlieKey();
            this.checkedStatus = 2;
          }
        });
      }
    }
  };

  var zqAddress = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-address flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('ZqAddressField',{attrs:{"field-data":Object.assign({}, _vm.$attrs.currentItem, {value: _vm.default_value}),"styles":_vm.$attrs.formData.advance_attribute.input.style,"labelStyle":_vm.$attrs.formData.advance_attribute.submitBtnText.style,"helpTextStyle":_vm.$attrs.formData.advance_attribute.helpText.style,"requiredAsteriskColor":_vm.$attrs.formData.basic_attribute.requiredAsteriskColor,"errorTextStyle":_vm.$attrs.formData.advance_attribute.errorText.style,"defaultLabelPadding":'24px 0 0',"placeholder":_vm.$attrs.currentItem.placeholder || '请选择',"clearable":!_vm.isMobile},model:{value:(_vm.default_value),callback:function ($$v) {_vm.default_value=$$v;},expression:"default_value"}})],1)],1)},
  staticRenderFns: [],
    name: "zqAddress",
    mixins: [mixin],
    components: { zqFormItem },
    inheritAttrs: false,
    props: {
      value: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {};
    },
    computed: {
      isMobile() {
        return isMobile();
      },
      default_value: {
        get() {
          const value = this.value[this.$attrs.currentItem.field_name];
          if (typeof value != 'object') {
            this.$set(this.value, this.$attrs.currentItem.field_name, {});
          }
          return this.value[this.$attrs.currentItem.field_name]
        },
        set(val) {
          this.value[this.$attrs.currentItem.field_name] = val;
        }
      }
    }

  };

  // import { formatDate } from 'element-ui/src/utils/date-util'
  var zqDateTimePicker = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-datetimepicker flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[(!_vm.isMobile)?[_c('ZqDateTimeField',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请选择日期时间',"value-format":"timestamp","clearable":""},on:{"change":_vm.dateTimeChange},model:{value:(_vm.dateTimeValue),callback:function ($$v) {_vm.dateTimeValue=$$v;},expression:"dateTimeValue"}})]:[_c('van-field',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"readonly":"","clickable":"","placeholder":_vm.$attrs.currentItem.placeholder || '请选择日期时间',"value":_vm.formatDate(_vm.dateTimeValue, _vm.dateTimeFormat),"left-icon":'icon el-icon-date',"clearable":""},on:{"click":_vm.showDatePickerFn}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v;},expression:"showDatePicker"}},[_c('van-datetime-picker',{ref:"date",attrs:{"title":"请选择日期时间","value":_vm.dateTimeValue ? new Date(_vm.dateTimeValue) : new Date(),"type":"datetime"},on:{"confirm":_vm.dateTimeConfirm,"cancel":function($event){_vm.showDatePicker = false;}}})],1)]],2)],1)},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    data() {
      //这里存放数据
      return {
        dateTimeValue: '',
        showDatePicker: false
      };
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    computed: {
      isMobile() {
        return isMobile()
      },
      extra_restrict_rule() {
        // 可能会是json
        return this.$attrs.currentItem.extra_restrict_rule || {}
      },
      date_format() { // 避免与mixin重名
        const date_format = this.extra_restrict_rule.date_format || 'yyyy-MM-dd';
        return this.format || date_format
      },
      timeFormat() {
        const time_format = this.extra_restrict_rule.time_format;
        const newFormat = time_format ? time_format.split(' ')[0] : 'HH:mm:ss';
        return this.format || newFormat
      },
      dateTimeFormat() {
        return this.date_format + ' ' + this.timeFormat
      }
    },
    //监控data中的数据变化
    watch: {
      value() {
        let date = parseInt(this.value[this.$attrs.currentItem.field_name]);
        this.dateTimeValue = this.formatTimestamp(date);
      },
    },
    mounted() {
      let date = parseInt(this.value[this.$attrs.currentItem.field_name]);
      this.dateTimeValue = this.formatTimestamp(date);
    },
    //方法集合
    methods: {
      // formatDate: formatDate,
      showDatePickerFn() {
        this.showDatePicker = true;
        this.$nextTick(() => {
          let dom = this.$refs.date.$el.querySelector('.van-picker__columns');
          copeIphoneXHomeIndicator(dom);
        });
      },
      dateTimeChange() {
        this.$set(
          this.value,
          this.$attrs.currentItem.field_name,
          this.dateTimeValue ? this.dateTimeValue / 1000 : ''
        );
        console.log(this.dateTimeValue,'this.dateTimeValue');
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      },
      dateTimeConfirm(data) {
        this.dateTimeValue = new Date(data).getTime();
        this.dateTimeChange();
        this.showDatePicker = false;
      },
      formatTimestamp(value) {
        if (!value) return ''
        return this.isMilliseconds(value) ? value : value * 1000
      },
      // 是否是毫秒级
      isMilliseconds(timestamp) {
        return timestamp >= 1e12
      }
    },
  };

  var zqDatePicker = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-datetimepicker flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[(!_vm.isMobile)?[_c('ZqDateTimeField',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"value-format":"timestamp","placeholder":_vm.$attrs.currentItem.placeholder || '请选择日期',"clearable":""},on:{"change":_vm.dateChange},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v;},expression:"dateValue"}})]:[_c('van-field',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"readonly":"","clickable":"","placeholder":_vm.$attrs.currentItem.placeholder || '请选择日期',"value":_vm.formatDate(_vm.dateValue, _vm.date_format),"clearable":true,"left-icon":'icon el-icon-date'},on:{"click":_vm.showPickerFn}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v;},expression:"showPicker"}},[_c('van-datetime-picker',{ref:"date",attrs:{"title":"选择日期","value":_vm.dateValue ? new Date(_vm.dateValue) : new Date(),"type":"date"},on:{"confirm":_vm.onConfirm,"cancel":function($event){_vm.showPicker = false;}}})],1)]],2)],1)},
  staticRenderFns: [],
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    data() {
      return {
        showPicker: false,
        dateValue: parseInt(this.value[this.$attrs.currentItem.field_name]) * 1000
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    //监听属性 类似于data概念
    computed: {
      isMobile() {
        return isMobile()
      },
      extra_restrict_rule() {
        // 可能会是json
        return this.$attrs.currentItem.extra_restrict_rule || {}
      },
      date_format() {
        const date_format = this.extra_restrict_rule.date_format || 'yyyy-MM-dd';
        return this.format || date_format
      }
    },
    //监控data中的数据变化
    watch: {
      value() {
        let date = parseInt(this.value[this.$attrs.currentItem.field_name]);
        this.dateValue = this.formatTimestamp(date);
      }
    },
    mounted() {
      let date = parseInt(this.value[this.$attrs.currentItem.field_name]);
      this.dateValue = this.formatTimestamp(date);
    },
    //方法集合
    methods: {
      // formatDate: formatDate,
      showPickerFn() {
        this.showPicker = true;
        this.$nextTick(() => {
          let dom = this.$refs.date.$el.querySelector('.van-picker__columns');
          copeIphoneXHomeIndicator(dom);
        });
      },
      onConfirm(data) {
        this.dateValue = new Date(data).getTime();
        this.dateChange();

        this.showPicker = false;
      },
      dateChange() {
        this.$set(
          this.value,
          this.$attrs.currentItem.field_name,
          this.dateValue ? this.dateValue / 1000 : ''
        );
        this.checkedFlieKey();
      },
      formatTimestamp(value) {
        if (!value) return ''
        return this.isMilliseconds(value) ? value : value * 1000
      },
      // 是否是毫秒级
      isMilliseconds(timestamp) {
        return timestamp >= 1e12
      }
    }
  };

  var zqTimePicker = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-form-datetimepicker flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[(!_vm.isMobile)?[_c('ZqDateTimeField',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请选择时间'},on:{"change":_vm.dateTimeChange},model:{value:(_vm.timeValue),callback:function ($$v) {_vm.timeValue=$$v;},expression:"timeValue"}})]:[_c('van-field',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"readonly":"","clickable":"","placeholder":_vm.$attrs.currentItem.placeholder || '请选择时间',"left-icon":'icon el-icon-time',"value":_vm.timeValue},on:{"click":_vm.showPickerFn}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPicker),callback:function ($$v) {_vm.showPicker=$$v;},expression:"showPicker"}},[_c('van-picker',{ref:"time",attrs:{"show-toolbar":"","title":"选择时间","columns":_vm.columns},on:{"confirm":_vm.onConfirm,"cancel":function($event){_vm.showPicker = false;}}})],1)]],2)],1)},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    data() {
      //这里存放数据
      return {
        showPicker: false,
        timeValue: this.value[this.$attrs.currentItem.field_name],
        columns: [
          // 第一列
          {
            values: [],
            defaultIndex: 0
          },
          // 第二列
          {
            values: [],
            defaultIndex: 0
          },
          // 第三列
          {
            values: [],
            defaultIndex: 0
          }
        ]
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    //监听属性 类似于data概念
    computed: {
      isMobile() {
        return isMobile()
      }
    },
    //监控data中的数据变化
    watch: {
      value() {
        this.timeValue = this.value[this.$attrs.currentItem.field_name];
        // 设置过默认值也需要触发或者为空
      }
    },
    mounted() {
      this.initDefaultIndex();
      this.initColumns();
    },
    //方法集合
    methods: {
      showPickerFn() {
        this.showPicker = true;
        this.$nextTick(() => {
          let dom = this.$refs.time.$el.querySelector('.van-picker__columns');
          copeIphoneXHomeIndicator(dom);
        });
      },
      onConfirm(data) {
        this.timeValue = data.join(':');
        this.dateTimeChange();
        this.showPicker = false;
      },
      dateFormat(type, time) {
        return this.$common.dateFormat(type, time)
      },
      dateTimeChange() {
        this.$set(
          this.value,
          this.$attrs.currentItem.field_name,
          this.timeValue ? this.timeValue : ''
        );

        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      },
      initDefaultIndex() {
        if (this.timeValue) {
          const [h, m, s] = this.timeValue.split(':');
          this.columns[0].defaultIndex = Number(h);
          this.columns[1].defaultIndex = Number(m);
          this.columns[2].defaultIndex = Number(s);
        }
      },
      initColumns() {
        for (let i = 0; i < 60; i++) {
          if (i < 24) {
            this.columns[0].values.push(this.padZero(i));
          }

          this.columns[1].values.push(this.padZero(i));
          this.columns[2].values.push(this.padZero(i));
        }
      },
      padZero(num, targetLength = 2) {
        let str = num + '';
        while (str.length < targetLength) {
          str = '0' + str;
        }
        return str
      }
    }
  };

  // import * as qiniu from "qiniu-js";
  async function upload(prifix, file, fname, key, onSuccess, uploadError, next) {
    const data = await service({
      url: prifix + "system/storage/upload-storage-token",
      method: "post",
      data: undefined
    });
    if (data.code !== 0) {
      uploadError();
      return;
    }
    let token = data.data;
    const putExtra = {
      fname: fname
    };
    const config = {};
    const observable = qiniu.upload(file, key, token, putExtra, config);
    observable.subscribe({
      next: next,
      error: uploadError,
      complete: onSuccess
    });
  }

  var zqUpload = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-upload-field"},[(_vm.uploadList.length > 0)?[(_vm.type === 'Image')?_vm._l((_vm.uploadList),function(item,index){return _c('div',{key:index,staticClass:"img-box",style:({ width: _vm.width, height: _vm.width })},[(!_vm.disabled)?_c('zq-icon',{staticClass:"delete-img",attrs:{"name":"icon-qingchu"},on:{"click":function($event){$event.stopPropagation();return _vm.handleRemove(index)}}}):_vm._e(),_vm._v(" "),_c('el-image',{attrs:{"src":item,"fit":'cover',"preview-src-list":_vm.uploadList}})],1)}):_vm._e(),_vm._v(" "),(_vm.type === 'Files')?_c('div',{staticClass:"files-list Files mt8"},_vm._l((_vm.uploadList),function(files,index){return _c('div',{key:files + index,staticClass:"Files files-item"},[_c('div',{staticClass:"lt flex"},[_c('zq-icon',{staticClass:"mr8",attrs:{"name":"icon-baipishu"}}),_vm._v(" "),_c('zq-ellipsis',{attrs:{"text":_vm.fileName(files)}})],1),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"delete-wrapper",on:{"click":function($event){$event.stopPropagation();return _vm.handleRemove(index)}}},[_c('zq-icon',{attrs:{"name":"icon-shanchuicon-normal"}})],1):_vm._e(),_vm._v(" "),(_vm.disabled && _vm.downLoadFilesBtnShow)?_c('zq-icon',{staticClass:"delete-wrapper leads-pointer",attrs:{"name":"icon-xiazai"},on:{"click":function($event){_vm.downLoadFiles(files, _vm.fileName(files));}}}):_vm._e()],1)}),0):_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.overUploadLimt && !_vm.disabled)?[_c('el-upload',{staticClass:"img-uploader",attrs:{"action":"","disabled":_vm.loading,"show-file-list":false,"accept":_vm.accept,"http-request":_vm.handleUploadRequest,"before-upload":_vm.beforeUpload}},[_c('div',{staticClass:"innner",attrs:{"slot":"default"},slot:"default"},[_c('zq-icon',{attrs:{"name":"icon-tianjiafenzu"}})],1)])]:_vm._e(),_vm._v(" "),(_vm.disabled && _vm.uploadList.length == 0)?_c('div',[_vm._v("-")]):_vm._e()],2)},
  staticRenderFns: [],
    props: {
      value: {
        type: [Array, String],
        default: () => ([])
      },
      field: {
        type: Object,
        default: () => {
          return {};
        },
      },
      type: {
        type: String,
        default: "Image",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: "80px",
      },
    },
    data() {
      return {
        uploadList: [],
        loading: false,
        defaultOptions: {
          Image: {
            type: "Image",
            btnText: "上传图片",
            keyName: "image_number",
            optionsType: ["image"],
          },
          Files: {
            type: "Files",
            btnText: "上传附件",
            keyName: "files_number",
            optionsType: ["file", "video", "audio"],
          },
        },
        previewImages: [],
      };
    },
    computed: {
      isMobile() {
        return isMobile()
      },
      extra_restrict_rule() {
        // 可能会是json
        return this.parseJSON(this.field.extra_restrict_rule) || {};
      },
      //是否超出数量限制
      overUploadLimt() {
        return this.uploadList.length >= this.extra_restrict_rule["max"];
      },
      //限定的类型
      accept() {
        const { files_format = [] } = this.extra_restrict_rule || {};
        return files_format.join(',')
      },
      downLoadFilesBtnShow() {
        return this.$fieldAuth.download(this.field);
      },
    },
    watch: {
      value:{
        handler(value){
          if(Array.isArray(value) && value.length){
            this.uploadList = value;
          }
        },
        deep: true,
        immediate: true
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.uploadList = this.field.value || [];
        this.loading = false;
      },
      getExtension(name) {
        return name.substring(name.lastIndexOf(".") + 1).toLowerCase();
      },
      handleUploadRequest() {},
      beforeUpload(file) {
        const size = file.size / 1024 / 1024;
        const format = this.getExtension(file.name);
        const fieldType = file.type.split("/")[0];
        const {
          max,
          image_limit_size=0,
          image_unit="M",
          video_limit_size=0,
          video_unit="M",
          audio_limit_size=0,
          audio_unit="M",
          file_limit_size=0,
          file_unit="M",
        } = this.extra_restrict_rule || {};

        if (!this.accept.includes(format)) {
          this.$zqMessage.error(`暂不支持${format}格式资源上传!`);
          return;
        }
        let maxSize = null;
        if (this.type == "Image") {
          maxSize = this.convertToMb(image_limit_size + image_unit);
        } else {
          if (fieldType == "video") {
            maxSize = this.convertToMb(video_limit_size + video_unit);
          } else if (fieldType == "audio") {
            maxSize = this.convertToMb(audio_limit_size + audio_unit);
          } else {
            maxSize = this.convertToMb(file_limit_size + file_unit);
          }
        }
        if (size > maxSize) {
          this.$zqMessage.error("上传的资源超出大小限制!");
          return;
        }
        if (this.uploadList.length >= max) {
          this.$zqMessage.error(`${this.field.display_name}最多只能上传${max}个`);
          return;
        }
        this.doUpload(file);
      },
      convertToMb(sizeStr) {
        const regex = /(\d+)([GM])/i;
        const match = sizeStr.match(regex);

        if (match) {
          const value = parseInt(match[1], 10);
          const unit = match[2].toUpperCase();

          if (unit === "G") {
            return value * 1024; // 1GB = 1024MB
          } else if (unit === "M") {
            return value; // Already in MB
          } else {
            throw new Error("Unsupported unit");
          }
        } else {
          throw new Error("Invalid format");
        }
      },
      handleRemove(index) {
        if (this.loading) {
          return false;
        }
        if (this.uploadList.length) {
          this.uploadList.splice(index, 1);
        }
        this.changeNotice();
      },
      doUpload(file) {
        this.loading = true;
        const name = `cdp/${file.uid}_${file.name}`;
        const fileName = file.name;
        upload(
          this.closest2('ZqFormPage').apiPrefix,
          file,
          fileName,
          name,
          this.uploadSuccess,
          this.uploadError
        );
      },
      uploadSuccess(data) {
        this.uploadList.push(`${this.$domain}${data.key}`);
        this.changeNotice();
        this.loading = false;
      },
      uploadError() {
        this.$zqMessage.error(`图片上传失败`);
      },
      //文件类型的名字处理
      fileName(item) {
        if (!item) return "-";
        const name = item.substr(item.lastIndexOf("/") + 1);
        return decodeURIComponent(name);
      },
      changeNotice() {
        this.$emit("change", this.field.field_name, this.uploadList);
      },
      //下载附件
      downLoadFiles(url, fileName) {
        const x = new window.XMLHttpRequest();
        x.open("GET", url, true);
        x.responseType = "blob";
        x.onload = () => {
          const url = window.URL.createObjectURL(x.response);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
        };
        x.send();
      },
      handleImagePreview(data, index) {
        this.previewImages = this.uploadList;
        this.$refs.imagePreview.show(index);
      },
      parseJSON(value) {
        try {
          const result = JSON.parse(value);
          return result;
        } catch (error) {
          return this.isObject(value) ? value : null;
        }
      },
      isObject(value) {
        return Object.prototype.toString.call(value) === "[object Object]";
      },
    },
  };

  var zqImage = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zq-upload',_vm._b({attrs:{"field":_vm.currentItem,"type":_vm.currentItem.field_type},on:{"change":_vm.onChange},model:{value:(_vm.value[_vm.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.currentItem.field_name, $$v);},expression:"value[currentItem.field_name]"}},'zq-upload',_vm.$attrs,false))],1)},
  staticRenderFns: [],
    name: 'ZqImageField',

    mixin: [mixin],

    components: { zqFormItem, zqUpload },

    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },

    computed: {
      currentItem() {
        return this.$attrs.currentItem
      }
    },

    methods: {
      onChange(field_name, val) {
        const newVal = Array.isArray(val) && val.length ? val : '';
        this.$set(this.value, field_name, newVal);
        this.$emit('change', field_name, newVal);
      }
    }
  };

  var zqAmount = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumberField',_vm._g(_vm._b({},'NumberField',_vm.$attrs,false),_vm.$listeners))},
  staticRenderFns: [],
    components: { NumberField: zqInputNumber }
  };

  var zqCompany = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zq-company-npmPackage"},[_c('div',{staticClass:"flex-auto"},[_c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[[(!_vm.isMobile)?_c('zq-select',{staticClass:"input-with-select",style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.placeholder,"popper-class":_vm.popperClass,"filterable":"","remote":"","clearable":"","remote-method":_vm.remoteMethod,"no-data-text":"未查询到该企业信息"},on:{"change":_vm.selectChange,"blur":_vm.selectBlur,"clear":function($event){_vm.value[_vm.$attrs.currentItem.field_name] = '';}},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name]"}},_vm._l((_vm.companyList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.enterprise_name,"value":item.enterprise_name}})}),1):_c('form',{staticClass:"mobile-form",attrs:{"action":"/"}},[_c('van-search',{staticClass:"zq-select input-with-select",style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"placeholder":_vm.$attrs.currentItem.placeholder || '搜索',"clearable":""},on:{"input":function (val) { return _vm.inputChange(val, true); },"blur":_vm.selectBlur,"clear":_vm.clearValue},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, (typeof $$v === 'string'? $$v.trim(): $$v));},expression:"value[$attrs.currentItem.field_name]"}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPicker),expression:"showPicker"}],staticClass:"mobile-company"},[(this.companyList.length > 0)?_vm._l((_vm.companyList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.handlerClick(item.enterprise_name)}}},[_vm._v("\n                "+_vm._s(item.enterprise_name)+"\n              ")])}):[_c('li',{staticClass:"empty"},[_vm._v("未查询到该企业信息")])]],2)],1)]],2)],1)])},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    components: { zqFormItem },
    inheritAttrs: false,
    mixins: [mixin],
    props: {
      value: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      //这里存放数据
      return {
        loading: false,
        isMobile: false,
        showPicker: false,
        companyList: [],
        inputValue: "",
        popperClass: "",
      };
    },
    watch: {
      value: {
        handler() {
          // 设置过默认值也需要触发或者为空
          let fileRules = this.$attrs.currentItem.fileRules;
          if (fileRules && fileRules.length > 0) {
            this.$nextTick(() => {
              this.checkedFlieKey();
            });
          }
        },
        deep: true,
      },
    },
    mounted() {
      this.isMobile = isMobile();
    },
    //方法集合
    methods: {
      remoteMethod(query) {
        if (this.$attrs.currentItem.forbid_manual_input_company !== 1) {
          this.inputValue = query;
        }
        if (query !== "") {
          service({
            url:
              this.closest2("ZqFormPage").apiPrefix +
              "leads/company/search-enterprise-client",
            method: "post",
            data: { keyword: query, org_id: this.$attrs.formData.org_id },
          })
            .then((res) => {
              if (res.code == 0) {
                this.loading = false;
                this.companyList = (res.data && res.data.item) || [];
                if (this.isMobile) {
                  this.showPicker = true;
                }
              } else {
                this.popperClass = 'hide-when-empty';
               
                this.loading = false;
              }
            })
            .catch(() => {
              if (this.isMobile) {
                this.showPicker = false;
              }
            });
        } else {
          if (this.isMobile) {
            this.showPicker = false;
          }
          this.companyList = [];
        }
      },
      //pc端select change
      selectChange(value) {
        this.inputValue = value;
        this.selectBlur();
      },
      //失去焦点
      selectBlur() {
        setTimeout(() => {
          if (
            this.$attrs.currentItem.forbid_manual_input_company == 1 &&
            this.isMobile
          ) {
            this.$set(
              this.value,
              this.$attrs.currentItem.field_name,
              this.inputValue
            );
          } else {
            this.$set(
              this.value,
              this.$attrs.currentItem.field_name,
              this.inputValue || this.value[this.$attrs.currentItem.field_name]
            );
          }
          console.log(this.$attrs.currentItem.forbid_manual_input_company);
          console.log(this.isMobile);
          this.showPicker = false;
        }, 0);
      },
      // 以下为C端代码
      handlerClick(value) {
        this.inputValue = value;
        this.selectBlur();
      },
      inputChange(val, picker) {
        setTimeout(() => {
          if (!picker) {
            this.showPicker = false;
            this.inputValue =
              val || this.value[this.$attrs.currentItem.field_name];
          }
          this.remoteMethod(val);
        }, 300);
      },
      clearValue() {
        this.value[this.$attrs.currentItem.field_name] = "";
        this.inputValue = "";
      },
    },
  };

  var zqPercentage = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NumberField',_vm._g(_vm._b({},'NumberField',_vm.$attrs,false),_vm.$listeners))},
  staticRenderFns: [],
    components: { NumberField: zqInputNumber }
  };

  var zqURL = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zq-text-field',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"placeholder":_vm.$attrs.currentItem.placeholder || '请输入'},on:{"blur":_vm.handlerChange},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, $$v);},expression:"value[$attrs.currentItem.field_name]"}})],1)},
  staticRenderFns: [],
    mixins: [mixin],
    components: { zqFormItem },
    inheritAttrs: false,
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      //这里存放数据
      return {}
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      handlerChange() {
        let fileRules = this.$attrs.currentItem.fileRules;
        if (fileRules.length > 0) {
          this.checkedFlieKey();
        }
      }
    }
  };

  var zqFiles = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZqImageField',_vm._g(_vm._b({},'ZqImageField',_vm.$attrs,false),_vm.$listeners))},
  staticRenderFns: [],
    name: 'ZqFilesField',
    components: { ZqImageField: zqImage }
  };

  // import { getLookupList } from '@/api/formManage/index'
  const getLookupList = () => {};
  var zqLookup = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zq-form-item',_vm._b({},'zq-form-item',_vm.$attrs,false),[_c('zqLookupField',{style:(_vm.$attrs.formData.advance_attribute.input.style),attrs:{"field-data":_vm.$attrs.currentItem,"getLookupList":_vm.getLookupList,"placeholder":_vm.$attrs.currentItem.placeholder || '请选择'},model:{value:(_vm.value[_vm.$attrs.currentItem.field_name]),callback:function ($$v) {_vm.$set(_vm.value, _vm.$attrs.currentItem.field_name, $$v);},expression:"value[$attrs.currentItem.field_name]"}})],1)},
  staticRenderFns: [],
    name: '',

    components: { zqFormItem },

    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {}
    },

    watch: {},

    mounted() {},

    methods: {
      getLookupList: getLookupList,
      handleSelectChange(selected, item) {
        const { id = '', name } = selected;
        this.$emit('input', id);
        this.$set(item, 'display_value', name);
      }
    }
  };

  var previewItemPanel = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previewItemPanel-2134243"},[_c(_vm.tag,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))],1)},
  staticRenderFns: [],
    name: "DraggableItem",
    //import引入的组件需要注入到对象中才能使用
    components: {
      phoneNumber,
      panel,
      zqInput,
      zqSelect,
      zqTextarea,
      zqRadio,
      zqCheckbox,
      zqInputNumber,
      zqEmail,
      zqAddress,
      zqDateTimePicker,
      zqDatePicker,
      zqTimePicker,
      zqImage,
      zqAmount,
      zqCompany,
      zqPercentage,
      zqURL,
      zqLookup,
      zqFiles
    },
    data() {
      //这里存放数据
      return {};
    },
    //监听属性 类似于data概念
    computed: {
      tag() {
        return this.$attrs.currentItem && this.$attrs.currentItem.tag;
      },
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      // this.$emit("input");
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  };

  var panel = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$attrs.currentItem.isShow && _vm.$attrs.currentItem.isHidden == 1)?_c('div',{},_vm._l((_vm.panelActiveChildren),function(item){return _c('preview-item-panel',_vm._g({key:item.field_name,staticClass:"draggable-item",attrs:{"currentItem":item,"formData":_vm.$attrs.formData},model:{value:(_vm.$attrs.value),callback:function ($$v) {_vm.$set(_vm.$attrs, "value", $$v);},expression:"$attrs.value"}},_vm.$listeners))}),1):_vm._e()},
  staticRenderFns: [],
    //import引入的组件需要注入到对象中才能使用
    name: "Panel",
    components: { previewItemPanel },
    props: {
      //这里接受参数
    },
    data() {
      //这里存放数据
      return {};
    },
    //监听属性 类似于data概念
    computed: {
      panelActiveChildren() {
        let activePanel = this.$attrs.currentItem.editableTabs.filter((item) => {
          return item.value == this.$attrs.currentItem.activeValue;
        });
        if (this.$attrs.currentItem.activeValue == "") {
          return [];
        } else {
          return activePanel[0].children;
        }
      },
    },
    //监控data中的数据变化
    watch: {
      "$attrs.value"() {

      },
    },
    //方法集合
    methods: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.$attrs.currentItem.isShow = false;
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  };

  var previewItem = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-item-21431443432"},[_c(_vm.tag,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners))],1)},
  staticRenderFns: [],
    name: "DraggableItem",
    //import引入的组件需要注入到对象中才能使用
    components: {
      phoneNumber,
      panel,
      zqInput,
      zqSelect,
      zqTextarea,
      zqRadio,
      zqCheckbox,
      zqInputNumber,
      zqEmail,
      zqAddress,
      zqDateTimePicker,
      zqDatePicker,
      zqTimePicker,
      zqImage,
      zqAmount,
      zqCompany,
      zqPercentage,
      zqURL,
      zqLookup,
      zqFiles
    },
    data() {
      //这里存放数据
      return {};
    },
    //监听属性 类似于data概念
    computed: {
      tag() {
        return this.$attrs.currentItem && this.$attrs.currentItem.tag;
      },
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  };

  var formPageMix = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-pagecore-1214343353543"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"form-page form-configuration-wrap fullscreen transparentScrollBar",style:([{ backgroundColor: ("" + (_vm.formBg ? _vm.formBg : _vm.cta_background)) }])},[(_vm.isEnlarge)?_c('div',{staticClass:"form-title"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.ctaTitleAndDesc)}})]):_vm._e(),_vm._v(" "),(!_vm.isPreview)?_c('div',{staticClass:"copy",attrs:{"data-clipboard-text":_vm.downloadUrl}}):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"from-warp"},[(!_vm.is_submit)?_c('div',{staticClass:"from-content"},[(_vm.formData.form_type == 1 && !_vm.isMobile)?_c('div',{style:('height: 24px;')}):_vm._e(),_vm._v(" "),_c('div',{class:{
              borderRadius6: _vm.formData.form_type == 1 && !_vm.isMobile
            }},[(_vm.formData.form_type == 1)?_c('div',{staticClass:"banner banner15"},[_c('el-image',{directives:[{name:"show",rawName:"v-show",value:(_vm.formData.basic_attribute.banner),expression:"formData.basic_attribute.banner"}],attrs:{"src":_vm.imageServerDomain() + _vm.formData.basic_attribute.banner,"fit":"fill"}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])],1):_vm._e(),_vm._v(" "),(!_vm.is_submit)?_c('div',{staticClass:"file-show-content"},[_c('div',{staticClass:"center-scrollbar center-scrollbar8"},[_c('div',{style:(_vm.formData.advance_attribute.page.style)},[_c('div',{class:{
                      pcSinglePadding24: !_vm.isMobile && _vm.formData.form_type == 1
                    }},[(_vm.formData.form_type == 1)?_c('div',{staticClass:"form-title"},[_c('div',{staticClass:"title",style:(_vm.formData.advance_attribute.title.style)},[_vm._v("\n                      "+_vm._s(_vm.formData.basic_attribute.title)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"inc",style:(_vm.formData.advance_attribute.introduction.style)},[_vm._v("\n                      "+_vm._s(_vm.formData.basic_attribute.introduction)+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"center-board-row"},[_c('el-form',{ref:"ruleForm",staticClass:"custom-form",attrs:{"label-position":"top","model":_vm.submitData,"hide-required-asterisk":true}},_vm._l((_vm.formData.field_content),function(item){return _c('preview-item',{key:item.field_name,staticClass:"draggable-item",attrs:{"currentItem":item,"formData":_vm.formData,"historyData":_vm.historyData,"submitData":_vm.submitData},on:{"change":_vm.handleChange},model:{value:(_vm.submitData),callback:function ($$v) {_vm.submitData=$$v;},expression:"submitData"}})}),1)],1),_vm._v(" "),(_vm.formData.is_privacy == 2)?_c('div',{staticClass:"privacy-warp-sub"},[_c('zq-checkbox',{model:{value:(_vm.isReadPrivacy),callback:function ($$v) {_vm.isReadPrivacy=$$v;},expression:"isReadPrivacy"}}),_vm._v(" "),_c('span',{staticClass:"privacytext",domProps:{"innerHTML":_vm._s(_vm.formData.basic_attribute.privacyText)},on:{"click":_vm.previewPrivacy}})],1):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"sumbit-btn",style:(_vm.formData.advance_attribute.submitBtn.style),on:{"click":function($event){$event.stopPropagation();return _vm.submitForm.apply(null, arguments)}}},[_c('span',{style:(_vm.formData.basic_attribute.submitBtnText.style)},[_vm._v(_vm._s(_vm.formData.basic_attribute.submitBtnText))])])],1)])])]):_vm._e()]),_vm._v(" "),(_vm.formData.form_type == 1 && !_vm.isMobile)?_c('div',{style:('height: 24px;')}):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.privacyMobileVisible)?_c('div',{staticClass:"privacy-warp-mobile-model"}):_vm._e(),_vm._v(" "),(_vm.privacyMobileVisible)?_c('div',{staticClass:"privacy-warp-mobile"},[_c('div',{staticClass:"privacy-title"},[_c('span',[_vm._v(_vm._s(_vm.privacyName))]),_vm._v(" "),_c('zq-icon',{attrs:{"name":"icon-guanbi"},on:{"click":function($event){_vm.privacyMobileVisible = false;}}})],1),_vm._v(" "),_c('div',{staticClass:"privacy-contant-warp"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.privacyContent)}})])]):_vm._e(),_vm._v(" "),_c('zq-dialog',{attrs:{"width":"880px","append-to-body":false,"modal-append-to-body":false,"title":_vm.privacyName,"visible":_vm.privacyPcVisible,"titleBottomBorder":true,"showCancelButton":false,"showConfirmButton":false},on:{"update:visible":function($event){_vm.privacyPcVisible=$event;}}},[_c('span',{staticClass:"privacy-content",domProps:{"innerHTML":_vm._s(_vm.privacyContent)}})]),_vm._v(" "),(_vm.is_submit && _vm.formData.form_type == 1)?_c('div',{staticClass:"submit-over"},[(_vm.formData.form_bg || _vm.formData.form_bg_m)?[(!_vm.isMobile)?_c('img',{attrs:{"src":_vm.imageServerDomain() + _vm.formData.form_bg}}):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('img',{attrs:{"src":_vm.formData.form_bg_m
                ? _vm.imageServerDomain() + _vm.formData.form_bg_m
                : _vm.imageServerDomain() + _vm.formData.form_bg}}):_vm._e()]:_c('img',{attrs:{"src":"https://cdn.beschannels.com/web-ui/lib/zq-public/utils/nodata.png"}}),_vm._v(" "),_c('span',{staticClass:"decs",domProps:{"innerHTML":_vm._s(_vm.formData.personal_display_content)}})],2):_vm._e()],1),_vm._v(" "),_c('zq-dialog',{attrs:{"visible":_vm.showMochatQrcode,"show-header":false,"footer-show":false,"width":_vm.isMobile ? '90%' : '462px'},on:{"update:visible":function($event){_vm.showMochatQrcode=$event;}}},[_c('div',{staticClass:"text-right"},[_c('zq-icon',{staticClass:"pointer",attrs:{"name":"icon-guanbi"},on:{"click":_vm.handleCloseMochatDialog}})],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h3',{staticClass:"fz20",style:({ color: _vm.mochat_code_info.mochat_title_color })},[_vm._v("\n        "+_vm._s(_vm.mochat_code_info.mochat_title)+"\n      ")]),_vm._v(" "),_c('img',{staticClass:"mt20 mb16",attrs:{"width":_vm.isMobile ? '100%' : 338,"src":_vm.mochat_qrcode_url,"alt":""}}),_vm._v(" "),_c('div',{style:({ color: _vm.mochat_code_info.mochat_describe_color })},[_vm._v("\n        "+_vm._s(_vm.mochat_code_info.mochat_describe)+"\n      ")])])]),_vm._v(" "),_c('zq-dialog',{class:[
        !_vm.isMobile,
        _vm.isMobile,
        'dialog-hint'
      ],attrs:{"visible":_vm.showPreviewHintDialog,"show-header":false,"footer-show":false,"width":_vm.isMobile ? '90%' : '462px'},on:{"update:visible":function($event){_vm.showPreviewHintDialog=$event;}}},[_c('div',{staticClass:"text-right"},[_c('zq-icon',{staticClass:"pointer",attrs:{"name":"icon-guanbi"},on:{"click":function($event){_vm.showPreviewHintDialog = false;}}})],1),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('zq-icon',{staticStyle:{"color":"rgb(255, 114, 79)","font-size":"36px"},attrs:{"name":"icon-jingshi"}}),_vm._v(" "),_c('h2',{staticClass:"mt16"},[_vm._v("提示")]),_vm._v(" "),_c('p',{staticClass:"mt16"},[_vm._v("此为预览页面，请勿推广使用")]),_vm._v(" "),_c('zq-button',{staticClass:"mt24",staticStyle:{"width":"80%"},attrs:{"type":"primary"},on:{"click":function($event){_vm.showPreviewHintDialog = false;}}},[_vm._v("我知道啦")])],1)])],1)},
  staticRenderFns: [],
    data() {
      return {
        isSubmitting: false,
        isMobile: false,
        showPop: true,
        testvisible: false,
        submitData: {},
        formData: {},
        historyData: {},
        loading: false,
        key: '',
        uo: '',
        success: false,
        is_submit: false,
        myCollect: null,
        privacyMobileVisible: false,
        privacyPcVisible: false,
        is_mobi: false,
        privacyName: '',
        privacyContent: '',
        isReadPrivacy: false,
        ppid: '', //父级页面id
        isStatistics: true, // 是否 需要统计
        downloadUrl: '', // 父页面有表单提交的下载动作
        module: '', // 父级的模块
        source: {}, // 访问链路
        isWeiXin: false,
        cta_background: '', //表单cta设置的背景颜色,
        decryptId: '',
        wechat: '',
        wechat_openid: '',
        wechat_appid: '',
        wechat_unionid: '',
        wechat_fans_info: '',
        fingerprint_id: localStorage.getItem('fingerprintId'),
        templateType: '',
        fieldListFlat: [],
        mochat_code_info: '',
        showMochatQrcode: false,
        mochat_qrcode_url: '',
        showPreviewHintDialog: false,//是否显示预览提示
      }
    },
    computed: {
      ctaTitleAndDesc() {
        return this.closest2('ZqFormPage').ctaTitleAndDesc
      },
      isEnlarge() {
        return this.closest2('ZqFormPage').isEnlarge
      },
      isPreview() {
        return this.closest2('ZqFormPage').isPreview
      },
      formBg() {
        if (
          this.formData &&
          this.formData.advance_attribute &&
          this.formData.advance_attribute.page &&
          this.formData.advance_attribute.page.style &&
          this.formData.advance_attribute.page.style.backgroundColor
        ) {
          return this.formData.advance_attribute.page.style.backgroundColor
        } else {
          return ''
        }
      }
    },
    components: { previewItem },

    mounted() {
      this.isMobile = isMobile();
      this.cta_background = this.closest2('ZqFormPage').params.ctaBackground || '';
      this.unique_id = this.closest2('ZqFormPage').params.unique_id || '';
      this.form_id = this.closest2('ZqFormPage').params.form_id || '';
      this.org_id = this.closest2('ZqFormPage').params.org_id || '';
      this.ppid = this.closest2('ZqFormPage').params.ppid || ''; //父页面id
      this.templateType = this.closest2('ZqFormPage').params.templateType || ''; //白皮书类型
      this.isStatistics =
        this.closest2('ZqFormPage').params.isStatistics == 2 ? false : true;
      this.downloadUrl = this.closest2('ZqFormPage').params.downloadUrl || '';
      this.module = this.closest2('ZqFormPage').params.module || '';
      this.pType = this.closest2('ZqFormPage').params.pType || '';
      this.pId = this.closest2('ZqFormPage').params.pId || '';
      this.gType = this.closest2('ZqFormPage').params.gType || '';
      this.gId = this.closest2('ZqFormPage').params.gId || '';
      this.zType = this.closest2('ZqFormPage').params.zType || '';
      this.zId = this.closest2('ZqFormPage').params.zId || '';
      this.wechat = this.$route.query.wechat ? this.$route.query.wechat : '';
      this.wechat_openid = localStorage.getItem(this.wechat + 'wechat_openid');
      this.wechat_appid = localStorage.getItem(this.wechat + 'wechat_appid');
      this.wechat_unionid = localStorage.getItem(this.wechat + 'wechat_unionid');
      this.wechat_fans_info = localStorage.getItem(
        this.wechat + 'wechat_fans_info'
      );
      this.getDetail();
      this.$nextTick(() => {
        if (document.getElementById('app')) {
          document.getElementById('app').setAttribute('class', 'fullscreen');
        }
      });
      this.uo = window.localStorage.getItem('uo') || '';
      this.is_mobi = this.isMobile;

      if (!this.isPreview) {
        if (this.is_mobi) {
          let head = document.getElementsByTagName('head');
          let meta = document.createElement('meta');
          meta.name = 'viewport';
          meta.content = 'initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
          head[0].appendChild(meta);
        }

        componentStoreCase.set('formPage', this);
      } else { 
        this.showPreviewHintDialog =true;
      }
    },
    methods: {
      imageServerDomain() {
        var res = this.closest2('ZqFormPage').imageServerDomain;
        return res
      },
      emitMsg(msgObj) {
        this.closest2('ZqFormPage').$emit('message', msgObj);
      },
      parentJump() {
        //此 parent不要动
        window.parent.location.href = this.formData.http_jump_link;
      },
      sendMessage() {
        this.emitMsg({
          type: 'cdp'
        });
      },
      checked(key, value) {
        // if (this.formData.is_auto_completion == 2) {
        this.getHistoryData(key, value, this.org_id);
        // }
      },
      getHistoryData(key, value, org_id) {
        let self = this;
        const fingerprintId = localStorage.getItem('fingerprintId');
        let params = {
          key,
          value,
          org_id,
          fingerprint_id: fingerprintId,
          form_id: this.decryptId
        };
        service({
          url: this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/get-info',
          method: 'post',
          data: params
        }).then(({ code, data }) => {
          if (code == 0 && data) {
            if (
              data &&
              data.is_submit == 1 &&
              self.formData.is_skip_submit == 2
            ) {
              if (this.formData.personal_display_type == 1) {
                this.is_submit = true;
              } else if (this.formData.personal_display_type == 2) {
                window.location.href = this.formData.http_jump_link;
              }
              return
            }
            if (this.formData.is_auto_completion == 1) return
            // if (self.submitData.Address) {
            //   self.submitData.Address.province = data.province
            //   self.submitData.Address.city = data.city
            //   self.submitData.Address.area = data.area
            // }
            self.historyData = data;
            let filedKey = Object.keys(data);
            let submitData = {};
            filedKey.forEach((item) => {
              submitData[item] = data[item];
            });

            this.submitData = {
              ...this.submitData,
              ...submitData
            };
          }
        });
      },

      async getDetail() {
        let self = this;

        let params;
        let api;
        if (!this.isPreview) {
          params = {
            form_id: this.form_id,
            org_id: this.org_id
          };

          api = service({
            url: this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/details',
            method: 'post',
            data: params
          });
        } else {
          params = {
            id: this.form_id,
            org_id: this.org_id
          };

          api = service({
            url:
              this.closest2('ZqFormPage').apiPrefix +
              'cdp/form-app/get-form-info',
            method: 'post',
            data: params
          });
        }

        api.then(({ code, data, msg }) => {
          if (code == 0) {
            self.decryptId = data.form_id; //解密之后的id
            if (!this.isPreview) {
              self.formData = JSON.parse(data.form_content);
              console.log(self.formData);
            } else {
              self.formData = data;
            }
            self.formData.advance_attribute = JSON.parse(
              self.formData.advance_attribute
            );
            self.formData.basic_attribute = JSON.parse(
              self.formData.basic_attribute
            );
            self.formData.field_content = JSON.parse(self.formData.field_content);
            console.log(self.formData.field_content);
            self.mochat_code_info = self.formData.mochat_code_info
              ? JSON.parse(self.formData.mochat_code_info)
              : '';

            self.$emit('onMounted');
            self.$emit('onFormDataChange', self.formData);

            if (this.isStatistics) {
              //防止多次初始化
              if (!this.closest2('ZqFormPage').myCollect) {
                this.closest2('ZqFormPage').myCollect = new Collect({
                  org_id: this.org_id,
                  customer_id: this.uo,
                  baseUrl: this.$trackUrl,
                  module_type: 'form',
                  target_type: (() => {
                    if (this.formData.form_type == 1) {
                      return 'alone'
                    } else {
                      return 'embed'
                    }
                  })(),
                  system_type: 'renew',
                  is_not_stat: '0',
                  wechat_openid: this.wechat_openid,
                  wechat_appid: this.wechat_appid,
                  wechat_fans_info: this.wechat_fans_info
                });
                this.closest2('ZqFormPage').myCollect.init({
                  page_view_auto: false,
                  element_click_auto: false
                });
              }
            }
            window.addEventListener('click', this.sendMessage);
            this.isWeiXin = this.isweiXin();

            this.$nextTick(() => {
              this.initData();
            });

            if (
              this.formData.basic_attribute.pageTitle &&
              this.formData.form_type == 1
            ) {
              document.title = this.formData.basic_attribute.pageTitle;
            }

            if (!this.isPreview) {
              if (this.uo && this.uo != 0) {
                this.key = 'customer_id';
                // if (this.formData.is_auto_completion == 2) {
                this.$nextTick(() => {
                  this.getHistoryData('renew_customer_id', this.uo, this.org_id);
                });
                // }
              } else if (this.wechat_openid && this.wechat_openid != '') {
                // if (this.formData.is_auto_completion == 2) {
                this.$nextTick(() => {
                  this.getHistoryData(
                    'renew_wechat_openid',
                    this.wechat_openid,
                    this.org_id
                  );
                });
                // }
              } else {
                // if (this.formData.is_auto_completion == 2) {
                const fingerprintId = localStorage.getItem('fingerprintId');
                this.$nextTick(() => {
                  this.getHistoryData(
                    'fingerprint_id',
                    fingerprintId,
                    this.org_id
                  );
                });
                // }
              }
              //页面访问买点
              let params = {
                is_not_stat: '0',
                target_type: this.formData.form_type == 1 ? 'alone' : 'embed',
                system_type: 'renew',
                page_id: this.decryptId, // 必传 页面id
                page_first_title: self.formData.form_name, // 可传 页面一级标题
                source_title: '', // 可传 页面来源
                parent_page_id: this.ppid,
                wechat_openid: this.wechat_openid,
                wechat_appid: this.wechat_appid,
                wechat_fans_info: this.wechat_fans_info,
                first_floor_id: this.pId,
                first_floor_type: this.pType,
                second_floor_id: this.gId,
                second_floor_type: this.gType
              };

              //单页面表单
              if (self.formData.form_type === 1) {
                params = {
                  ...params
                  // ...getUtmJson(location, 'link'),
                };
              }

              // 父级为未发布态 不需要统计
              if (this.isStatistics) {
                //防止多次统计
                if (!this.closest2('ZqFormPage').formVisited) {
                  this.closest2('ZqFormPage').myCollect.$visit(params);
                  this.closest2('ZqFormPage').formVisited = true;
                }
              }
            }
          } else {
            this.$zqMessage.error(msg);
          }
        });
      },
      initData() {
        let submitData = {};
        this.formData.field_content.forEach((item) => {
          if (item.tag != 'panel') {
            submitData[item.field_name] = item.default_value;
          }
          if (item.tag == 'panel') {
            item.editableTabs.forEach((panle) => {
              if (panle.children.length > 0) {
                panle.children.forEach((panelFile) => {
                  submitData[panelFile.field_name] = panelFile.default_value;
                });
              }
            });
          }
        });
        this.submitData = submitData;
        this.success = true;
      },
      previewPrivacy() {
        if (!this.formData.privacy_id) return
        let params = {
          org_id: this.org_id,
          id: this.formData.privacy_id
        };
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix +
            'cdp/form-app/privacy-details',
          method: 'post',
          data: params
        }).then(({ code, data, msg }) => {
          if (code == 0) {
            this.privacyContent = data.privacy_content;
            this.privacyName = data.privacy_name;
            if (this.is_mobi) {
              this.privacyMobileVisible = true;
            } else {
              this.privacyPcVisible = true;
            }
          } else {
            this.$zqMessage.error(msg);
          }
        });
      },
      getAddressItem(addressData, field_name) {
        if (!Array.isArray(addressData)) return false
        const current = addressData.find(
          (item) =>
            item.field_name == field_name || item.nick_field_name == field_name
        );
        return current || {}
      },
      validateMessage() {
        let hasObjectNoValue = false;
        //初始化检验字段列表
        this.fieldListFlat = [];
        this.formData.field_content.forEach((item) => {
          if (item.tag != 'panel') {
            this.fieldListFlat.push(item);
          }
          if (item.tag == 'panel') {
            item.editableTabs.forEach((panle) => {
              if (panle.children.length > 0 && panle.value == item.activeValue) {
                panle.children.forEach((panelFile) => {
                  this.fieldListFlat.push(panelFile);
                });
              }
            });
          }
        });
        for (const fieldKey of Object.keys(this.submitData)) {
          const fieldContent = this.fieldListFlat || [];
          const currentField = fieldContent.find(
            ({ field_name }) => field_name === fieldKey
          );
          if (!currentField) continue

          const { field_type, isHidden, is_required, display_name } = currentField;
          const fieldValue = this.submitData[fieldKey];

          // 通用字段校验
          if (this.isEmpty(fieldValue) && isHidden === 1 && is_required === 2) {
            // this.$zqMessage.error(`${display_name}为必填项`)
            hasObjectNoValue = true;
            break // 终止循环
          }

          // 地址类型校验
          if (isHidden === 1 && field_type === 'Address') {
            const addressValue = fieldValue || {};
            const addressRuleList = currentField.extra_restrict_rule.address;
            for (const key of Object.keys(addressValue)) {
              const {
                is_open,
                is_required,
                display_name: displayName
              } = this.getAddressItem(addressRuleList, key);
              if (
                key !== 'area' &&
                is_open === 1 &&
                is_required === 1 &&
                !addressValue[key]
              ) {
                // this.$zqMessage.error(`${display_name} -- ${displayName}为必填项`)
                hasObjectNoValue = true;
                break // 终止地址校验循环
              }
            }

            if (hasObjectNoValue) break // 终止主循环
          }
        }
        return hasObjectNoValue
      },
      submitForm() {
        console.log(this.submitData);
        //防止重复提交
        if (this.isSubmitting === true) {
          return
        }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // if (this.validateMessage()) return
            if (this.formData.is_privacy == 2 && !this.isReadPrivacy) {
              const { privacy_custom_tips  } =
                this.formData.basic_attribute || {};
              this.$zqMessage.error(privacy_custom_tips.trim() || '请先阅读隐私条款');
              return false
            }

            if (!this.isPreview) {
              let submitPanelData = {};
              this.formData.field_content.forEach((item) => {
                if (item.tag == 'panel' && item.isEdit) {
                  submitPanelData[item.field_name] = item.activeValue;
                }
              });
              // 父级为未发布态 不需要统计
              if (!this.isStatistics) {
                if (this.downloadUrl && this.downloadUrl != 'undefiend') {
                  // if (this.isWeiXin) {
                  //   this.emitMsg({ type: 'cdpDownload' });
                  // } else {
                  //   self.download(this.downloadUrl);
                  // }
                  this.emitMsg({ type: 'cdpDownload' });
                }
                this.is_submit = true;
                this.$emit('onSubmitSuccess', true);
                return false
              }
              if (this.zType && this.zType != 'undefiend') {
                this.source[this.zType] = this.zId;
              }
              if (this.gType && this.gType != 'undefiend') {
                this.source[this.gType] = this.gId;
              }
              if (this.pType && this.pType != 'undefiend') {
                this.source[this.pType] = this.pId;
              }

              // let newParams = {
              //   target_type: (()=>{
              //     if(this.formData.form_type == 1){
              //       return 'alone'
              //     }else{
              //       return 'embed'
              //     }
              //   })(),
              //
              //   // first_floor_type: (()=>{
              //   //   if(this.formData.form_type == 1){
              //   //     return undefined
              //   //   }else{
              //   //     return 'fcta'
              //   //   }
              //   // })(),
              //   // first_floor_id: (()=>{
              //   //   if(this.formData.form_type == 1){
              //   //     return undefined
              //   //   }else{
              //   //     return this.pId
              //   //   }
              //   // })(),
              //   // second_floor_type: (()=>{
              //   //   if(this.formData.form_type == 1){
              //   //     return undefined
              //   //   }else{
              //   //     return 'content'
              //   //   }
              //   // })(),
              //   // second_floor_id: (()=>{
              //   //   if(this.formData.form_type == 1){
              //   //     return undefined
              //   //   }else{
              //   //     return this.gId
              //   //   }
              //   // })(),
              //
              // }
              const params = {
                target_type: (() => {
                  if (this.formData.form_type == 1) {
                    return 'alone'
                  } else {
                    return 'embed'
                  }
                })(),
                system_type: 'renew',
                anonymous_id:
                  this.closest2('ZqFormPage').myCollect.$getAnonymousId(),
                fingerprint_id: localStorage.getItem('fingerprintId'),
                unique_id: this.unique_id,
                org_id: this.org_id,
                ...this.submitData,
                ...submitPanelData,
                module: this.module,
                source: this.source,
                form_id: this.decryptId,
                clientresources: {
                  customer_id: window.localStorage.getItem('uo'),
                  secretcode: window.localStorage.getItem('secretcode')
                },
                wechat_openid: this.wechat_openid,
                wechat_appid: this.wechat_appid,
                wechat_fans_info: this.wechat_fans_info
              };

              //下载统计
              //if (this.downloadUrl && this.downloadUrl != 'undefiend') {
              params.source.utm = getUtmJson(location, 'download');
              //}

              this.isSubmitting = true;
              service({
                url:
                  this.closest2('ZqFormPage').apiPrefix + 'cdp/form-app/commit',
                method: 'post',
                data: params
              })
                .then(({ code, data, msg }) => {
                  //感谢语， 立即解锁按钮
                  if (this.formData.personal_display_type == 1) {
                    this.isSubmitting = false;
                  }
                  //跳转链接  等待链接页面打开后， 解锁按钮
                  else if (this.formData.personal_display_type == 2) {
                    setTimeout(() => {
                      this.isSubmitting = false;
                    }, 5000);
                  }

                  if (code == 0) {
                    this.$emit('onSubmitSuccess', true);

                    localStorage.setItem('customer_id', data.customer_id);
                    // 先下载 cms 需求
                    if (this.downloadUrl && this.downloadUrl != 'undefiend') {
                      // if (this.isWeiXin) {
                      //   this.emitMsg({ type: 'cdpDownload' });
                      // } else {
                      //   self.download(this.downloadUrl);
                      // }
                      this.emitMsg({ type: 'cdpDownload' });
                    }
                    const { open_mochat } = this.formData;
                    if (this.formData.personal_display_type == 1) {
                      if (open_mochat == 1) {
                        this.getMochatCodeByUser(params.MobilePhone);
                      } else {
                        this.callpPersonalDisplayType1();
                      }
                    } else if (this.formData.personal_display_type == 2) {
                      if (open_mochat == 1) {
                        this.getMochatCodeByUser(params.MobilePhone);
                      } else {
                        this.callpPersonalDisplayType2();
                      }
                    }
                    window.localStorage.setItem('uo', data.customer_id);
                    window.localStorage.setItem('secretcode', data.secretcode);
                  } else {
                    this.$zqMessage.error(msg);
                  }
                })
                .catch(() => {
                  this.isSubmitting = false;
                });
            } else {
              this.$emit('onSubmitSuccess', true);
              if (this.formData.personal_display_type == 1) {
                this.is_submit = true;
              } else if (this.formData.personal_display_type == 2) {
                window.location.href = this.formData.http_jump_link;
              }
            }
          } else {
            // const flag = this.validateMessage()
            // if (!flag) {
            //   this.$zqMessage.error('表单信息填写不完整或信息填写错误，请继续填写完整')
            // }
            return false
          }
        });
      },
      callpPersonalDisplayType1() {
        this.is_submit = true;
      },
      callpPersonalDisplayType2() {
        if (window.self === window.top) {
          this.fnPageJump();
        } else {
          // false 说明被iframe嵌套的 如 在cta中预览嵌套表单
          if (this.isMobile) {
            // 因safari的安全机制将“异步”window.open阻挡了所以采用localtion
            // 被两级iframe嵌套了
            this.parentJump();
          } else {
            this.fnPageJump();
          }
        }
      },
      // 打开新页面跳转 (解决浏览器默认阻止打开新页面)
      fnPageJump() {
        if (this.isMobile) {
          window.location.href = this.formData.http_jump_link;
        } else {
          // 用户点击时 => 浏览器打开一个空白页
          this.newTab = window.open(`'about:blank'`);
          // 重定向至目标页面
          this.newTab.location.href = this.formData.http_jump_link;
        }
      },
      download(url) {
        let a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      //判断是否是微信浏览器的函数
      isweiXin() {
        //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          return true
        } else {
          return false
        }
      },
      getMochatCodeByUser(MobilePhone) {
        const { utm_campaign, utm_source, utm_medium, utm_term, utm_content } =
          this.$route.query;
        let params = {
          orgId: this.org_id,
          code_id: this.mochat_code_info.mochat_code_id || '',
          mobile: MobilePhone || '',
          unionid: this.wechat_unionid,
          open_id: this.wechat_openid,
          fingerprint_id: this.fingerprint_id || '',
          utm_campaign: utm_campaign || '',
          utm_source: utm_source || '',
          utm_medium: utm_medium || '',
          utm_term: utm_term || '',
          utm_content: utm_content || '',
          app_type: '9', // 9 白皮书
          app_id: this.formData.id,
          app_link: encodeURIComponent(window.location.href),
          app_name: this.formData.form_name
        };
        const sign = crypto__default["default"]
          .MD5(JSON.stringify(params) + 'jvmzISMCzQeP0BB7ocnSN8nnadBcqQjN')
          .toString();
        params.sign = sign;
        service({
          url:
            this.closest2('ZqFormPage').apiPrefix +
            'mochat/channel-code/code/handleCodeByUser',
          method: 'post',
          data: params
        }).then((res) => {
          if (res.code == 200) {
            this.mochat_qrcode_url = res.data.qrcode_url;
            this.showMochatQrcode = true;
          } else {
            // this.$zqMessage.error(res.msg);
            this.handleCloseMochatDialog();
          }
        });
      },
      handleCloseMochatDialog() {
        this.showMochatQrcode = false;
        const mochat_code_id = this.mochat_code_info.mochat_code_id;
        const { open_mochat, personal_display_type } = this.formData;
        if (open_mochat == 1 && mochat_code_id) {
          if (personal_display_type == 1) {
            this.callpPersonalDisplayType1();
          } else if (personal_display_type == 2) {
            this.callpPersonalDisplayType2();
          }
        }
      },
      isEmpty(value) {
        // null or undefined
        if (value == null) return true
        // Strings
        if (typeof value === 'string' && value.trim() === '') return true
        // Arrays
        if (Array.isArray(value) && value.length === 0) return true
        // Objects
        if (typeof value === 'object' && Object.keys(value).length === 0)
          return true
        // NaN
        if (typeof value === 'number' && isNaN(value)) return true
        // Everything else is considered non-empty
        return false
      },
      handleChange(field_name) {
        this.$refs['ruleForm'].validateField(field_name);
      }
    },
    watch: {},
    beforeDestroy() {
      componentStoreCase.clear('formPage');
      window.removeEventListener('click', this.sendMessage);
    } //生命周期 - 销毁之前
  };

  var Skeleton = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"background":"white"}},[_c('van-skeleton',{staticStyle:{"height":"100%","overflow":"hidden"},attrs:{"title":"","row":20}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('formPageMix',{attrs:{"isFormPage":_vm.isFormPage()},on:{"onSubmitSuccess":function($event){return _vm.$emit('onSubmitSuccess', true)},"onMounted":function($event){_vm.loading = false;}}})],1)])},
  staticRenderFns: [],
    name: "Skeleton",
    data() {
      return {
        loading: true,
      };
    },
    props: {
      type: {
        type: String,
        default() {
          return "formPage";
        },
      },
    },
    components: {
      formPageMix,
    },
    methods: {
      isFormPage() {
        return true;
      },
    },
  };

  var popup = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"formTypeFinder",staticStyle:{"display":"none"}},[_vm._v("\n    "+_vm._s(_vm.formData.form_type == 1 ? '单页面表单' : '嵌入式表单')+"\n  ")]),_vm._v(" "),_c('div',[(_vm.formData.form_type == 2)?_c('div',[(!_vm.isEnlarge())?_c('div',[_c('div',{staticClass:"transparentOverLay",on:{"click":_vm.popupForm}}),_vm._v(" "),_c('Skeleton',{key:_vm.skeletonKey,attrs:{"type":_vm.type,"loading":_vm.loading},on:{"onSubmitSuccess":_vm.onSubmitSuccess}})],1):_c('div',[(_vm.isMobile)?_c('div',{staticClass:"mobileEmbed"},[_c('div',{staticStyle:{"width":"100%","height":"100%","position":"fixed","top":"0px","left":"0px","z-index":"100000000000"}},[_c('div',{staticStyle:{"height":"80%","width":"100%","top":"20%","position":"absolute","z-index":"2","background":"white"}},[_c('flexBox',[_c('div',{attrs:{"slot":"head"},slot:"head"},[_c('div',[_c('div',{staticClass:"mobilePopTitle"},[_vm._v("表单填写")]),_vm._v(" "),_c('zq-icon',{staticClass:"icon-qingchuMobile",attrs:{"name":"icon-shanchuyixuanchengyuan"},on:{"click":function($event){$event.stopPropagation();return _vm.dePopupForm.apply(null, arguments)}}})],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"box",style:('background:' +
                        _vm.formData.advance_attribute.page.style.backgroundColor)},[_c('Skeleton',{key:_vm.skeletonKey,attrs:{"type":_vm.type,"loading":_vm.loading},on:{"onSubmitSuccess":_vm.onSubmitSuccess}})],1)])])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"100%","background":"rgb(0, 0, 0)","opacity":"0.66","position":"absolute","top":"0px","left":"0px","z-index":"1"}})])]):_c('div',{staticClass:"pcEmbed"},[_c('div',{staticClass:"whiteBg",style:('backgroundColor:' + _vm.whiteBg)},[(_vm.isEnlarge())?_c('zq-icon',{staticClass:"icon-qingchu icon-qingchu-pcPopup",attrs:{"name":"icon-qingchu"},on:{"click":function($event){$event.stopPropagation();return _vm.dePopupForm.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fullscreenInnerWrap transparentScrollBar"},[_c('div',{staticClass:"centerBox"},[_c('Skeleton',{key:_vm.skeletonKey,attrs:{"type":_vm.type,"loading":_vm.loading},on:{"onSubmitSuccess":_vm.onSubmitSuccess}})],1)])],1)])])]):_c('div',[(_vm.isMobile)?_c('div',{staticClass:"mobileSingle"},[_c('Skeleton',{key:_vm.skeletonKey,attrs:{"type":_vm.type,"loading":_vm.loading},on:{"onSubmitSuccess":_vm.onSubmitSuccess}})],1):_c('div',{staticClass:"pcSingle"},[_c('Skeleton',{key:_vm.skeletonKey,attrs:{"type":_vm.type,"loading":_vm.loading},on:{"onSubmitSuccess":_vm.onSubmitSuccess}})],1)]),_vm._v(" "),(_vm.submitSuccess && _vm.formData.form_type == 2)?_c('div',{staticClass:"submit-over2",style:({
          background: _vm.form_bg_url ? 'url(' + _vm.form_bg_url + ')' : '#2b3d4f',
          backgroundSize: '100%',
        })},[_c('img',{attrs:{"src":"https://cdn.beschannels.com/web-ui/lib/zq-public/utils/submitSuccess.png"}}),_vm._v(" "),_c('div',{staticClass:"decs",domProps:{"innerHTML":_vm._s(_vm.formData.personal_display_content)}}),_vm._v(" "),_c('zq-button',{staticClass:"submitBtn mt32",attrs:{"plain":""},on:{"click":_vm.reSubmit}},[_vm._v("\n        重新提交\n      ")])],1):_vm._e()])])},
  staticRenderFns: [],
    name: 'popup',
    data() {
      return {
        skeletonKey: Date.now(),
        isMobile: false,
        loading: true,

        submitSuccess: false,
        formData: {
          form_type: 1,
        },
        form_bg_url: '',
      };
    },
    components: {
      flexBox,
      Skeleton,
    },
    props: {
      type: {
        type: String,
        default() {
          return 'formPage';
        },
      },
    },
    computed: {
      showQingchuMobile: {
        cache: false,
        get: function () {
          let res = false;
          if (this.isMobile) {
            if (this.isEnlarge()) {
              if (!this.submitSuccess) {
                res = true;
              }
            }
          }
          return res;
        },
      },
      whiteBg: {
        cache: false,
        get: function () {
          if (
            this.formData &&
            this.formData.advance_attribute &&
            this.formData.advance_attribute.page &&
            this.formData.advance_attribute.page.style &&
            this.formData.advance_attribute.page.style.backgroundColor
          ) {
            return this.formData.advance_attribute.page.style.backgroundColor;
          } else {
            return 'white';
          }
        },
      },
    },
    methods: {
      imageServerDomain() {
        var res = this.closest2('ZqFormPage').imageServerDomain;
        return res;
      },
      onSubmitSuccess(val) {
        this.submitSuccess = val;
        if (this.formData.form_type == 2) {
          this.shrinkIframes();
        }
      },
      reSubmit() {
        this.submitSuccess = false;
        this.enlargeIframes();
        this.skeletonKey = Date.now();
      },
      shrinkIframes() {
        this.effect('remove');
        this.closest2('ZqFormPage').isEnlarge = false;
      },
      effect(type) {
        document.querySelectorAll('.formPageBox').forEach((ele) => {
          if (ele !== this.closest2('ZqFormPage').$el) {
            ele.classList[type]('hidden');
          }
        });
        document.querySelectorAll('.formPageBox')[0] ===
          document.querySelectorAll('.formPageBox')[0];

        var carousels = [];
        var subCarousels = document.querySelectorAll(
          '.el-carousel__item.is-active'
        );
        subCarousels.forEach((ele) => {
          carousels.push(ele);
        });
        if (!(carousels && carousels.length)) {
          carousels = document.querySelectorAll('.van-swipe__track');
        }
        if (carousels && carousels.length) {
          for (var i = 0; i < carousels.length; i++) {
            carousels[i].classList[type]('noTransform');
          }
        }

        document.querySelectorAll('.p-nav-search').forEach((pNavSearch) => {
          pNavSearch.classList[
            (() => {
              if (type === 'add') {
                return 'remove';
              } else {
                return 'add';
              }
            })()
          ]('zIndex100000000');
        });

        document.querySelectorAll('.el-carousel__arrow').forEach((carousel) => {
          carousel.classList[type]('zIndex0');
        });
      },
      isEnlarge() {
        return this.closest2('ZqFormPage').isEnlarge;
      },
      enlargeIframes() {
        this.effect('add');
        if (this.enlargeIframestimer) {
          clearTimeout(this.enlargeIframestimer);
        }
        this.enlargeIframestimer = setTimeout(() => {
          clearTimeout(this.enlargeIframestimer);
          this.closest2('ZqFormPage').isEnlarge = true;
        }, 600);
      },
      popupForm() {
        this.loading = true;
        this.enlargeIframes();
        this.closest2('ZqFormPage').$emit('popupShrink', 'popup');
      },
      dePopupForm() {
        this.loading = true;
        this.shrinkIframes('reset');
        this.closest2('ZqFormPage').$emit('popupShrink', 'shrink');
      },
      sendMessage2(msgObj) {
        if (window.frameElement && window.frameElement.message) {
          window.frameElement.message(msgObj);
        }
      },
    },
    mounted() {
      this.isMobile = isMobile();
      this.sendMessage2({
        type: 'mounted',
      });

      let self = this;
      self.formData = self.closest2('ZqFormPage').formData;
      self.loading = false;

      document.documentElement.classList.add('borderRadius');
      console.log(this, '-----popup-----');
      componentStoreCase.set('popup', this);
      let templateType = self.closest2('ZqFormPage').params.templateType || '';
      if (templateType == 1) {
        if (this.formData.white_form_bg) {
          this.form_bg_url = this.isMobile
            ? this.formData.white_form_bg_m
              ? this.imageServerDomain() + this.formData.white_form_bg_m
              : this.imageServerDomain() + this.formData.white_form_bg
            : this.imageServerDomain() + this.formData.white_form_bg;
        }
      } else {
        if (this.formData.form_bg) {
          this.form_bg_url = this.isMobile
            ? this.formData.form_bg_m
              ? this.imageServerDomain() + this.formData.form_bg_m
              : this.imageServerDomain() + this.formData.form_bg
            : this.imageServerDomain() + this.formData.form_bg;
        }
      }
    },
    beforeDestroy() {
      componentStoreCase.clear('popup');
    }, //生命周期 - 销毁之前
  };

  var ZqFormPage = {
  render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
      formPageBox: true,
      enlargeIframe: _vm.isEnlarge,
      isEmbed: _vm.formData && _vm.formData.form_type !== 1,
      isMobile: _vm.isMobile,
      inIframe: _vm.inIframe,
    },on:{"click":function($event){$event.stopPropagation();return (function () {}).apply(null, arguments)}}},[(_vm.formData)?_c('popup',{attrs:{"type":'formPage'}}):_vm._e()],1)},
  staticRenderFns: [],
    name: 'ZqFormPage',
    data() {
      return {
        isMobile: false,
        formData: null,
        isEnlarge: false,
      };
    },
    components: {
      popup,
    },
    computed: {
      apiPrefix() {
        if (
          location.pathname.match('web-mobile') &&
          location.host.match('localhost')
        ) {
          let res = '/cdpApi/';
          // if(this.apiBaseUrl){
          //   res = this.apiBaseUrl + '/'
          // }

          return res;
        } else {
          let res = '/api/';
          if (this.apiBaseUrl) {
            res = this.apiBaseUrl + '/';
          }
          return res;
        }
      },
    },
    props: {
      apiBaseUrl: {
        type: String,
        default: '',
      },
      inIframe: {
        type: Boolean,
        default: true,
      },
      ctaTitleAndDesc: {
        type: String,
        default() {
          return '';
        },
      },
      isPreview: {
        type: Boolean,
        default() {
          return false;
        },
      },
      imageServerDomain: {
        type: String,
        default() {
          return '';
        },
      },
      params: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      getDetail() {
        let self = this;
        if (!this.isPreview) {
          let params = {
            form_id: this.params.form_id,
            org_id: this.params.org_id,
          };
          service({
            url: this.apiPrefix + 'cdp/form-app/details',
            method: 'post',
            data: params,
          }).then(({ code, data, msg }) => {
            if (code == 0) {
              self.formData = JSON.parse(data.form_content);
              self.formData.advance_attribute = JSON.parse(
                self.formData.advance_attribute
              );
              self.formData.basic_attribute = JSON.parse(
                self.formData.basic_attribute
              );
              self.formData.field_content = JSON.parse(
                self.formData.field_content
              );
            } else {
              this.$zqMessage.error(msg);
            }
          });
        } else {
          let params = {
            id: this.params.form_id,
            org_id: this.params.org_id,
          };
          service({
            url: this.apiPrefix + 'cdp/form-app/get-form-info',
            method: 'post',
            data: params,
          }).then(({ code, data, msg }) => {
            if (code == 0) {
              self.formData = data;
              self.formData.advance_attribute = JSON.parse(
                self.formData.advance_attribute
              );
              self.formData.basic_attribute = JSON.parse(
                self.formData.basic_attribute
              );
              self.formData.field_content = JSON.parse(
                self.formData.field_content
              );
            } else {
              this.$zqMessage.error(msg);
            }
          });
        }
      },
    },
    mounted() {
      console.log(this.params, '---params');
      this.isMobile = isMobile();
      this.getDetail();
    },
  };

  /* istanbul ignore next */
  ZqFormPage.install = function (Vue) {
    Vue.component(ZqFormPage.name, ZqFormPage);
  };

  return ZqFormPage;

}));
